/* Water When Dry — behaviour.

   Everything here is an enhancement. With this file blocked: size radios still
   carry name="id" so the right variant posts, every add-to-cart form still
   posts to /cart, and the cart page still works. Nothing below is load-bearing
   for a purchase — it only makes the purchase quicker and more honest. */

(function () {
  'use strict';

  /* ── the product page ────────────────────────────────────────────────────
     A size radio changes what is true about the page: the price, whether it
     can be bought, and which photograph is showing. Before this, the page
     described the first variant no matter which size you picked. */
  function bindProduct(pdp) {
    var data = document.querySelector('[data-variants]');
    if (!data) return;

    var variants;
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var priceEl = pdp.querySelector('[data-price]');
    var compareEl = pdp.querySelector('[data-compare]');
    var addBtn = pdp.querySelector('[data-add]');
    var addText = pdp.querySelector('[data-add-text]');
    var radios = pdp.querySelectorAll('input[name="id"][data-variant]');

    function find(id) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return null;
    }

    function apply(v) {
      if (!v) return;

      if (priceEl) priceEl.innerHTML = v.price;

      if (compareEl) {
        if (v.onSale > 0 && v.compare) {
          compareEl.innerHTML = v.compare;
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      if (addBtn) {
        addBtn.disabled = !v.available;
        if (v.available) { addBtn.removeAttribute('aria-disabled'); }
        else { addBtn.setAttribute('aria-disabled', 'true'); }
      }
      if (addText) {
        addText.textContent = v.available
          ? (addText.getAttribute('data-in') || addText.textContent)
          : (addText.getAttribute('data-out') || addText.textContent);
      }

      // Bring the matching photograph into view rather than swapping it out
      // from under the customer.
      if (v.mediaId) {
        var shot = pdp.querySelector('[data-media-id="' + v.mediaId + '"]');
        if (shot && shot.scrollIntoView) {
          var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          shot.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest' });
        }
      }

      // Keep the address bar honest, so a shared link opens the size chosen.
      if (v.url && window.history && window.history.replaceState) {
        window.history.replaceState({}, '', v.url);
      }
    }

    Array.prototype.forEach.call(radios, function (r) {
      r.addEventListener('change', function () { apply(find(r.value)); });
    });
  }

  /* ── the cart drawer ─────────────────────────────────────────────────────
     Re-rendered on the server after every change, so prices and discounts are
     never reassembled by hand here. */
  var Drawer = {
    root: null,
    lastFocus: null,

    get: function () {
      if (!this.root || !document.contains(this.root)) {
        this.root = document.querySelector('[data-drawer]');
      }
      return this.root;
    },

    open: function () {
      var d = this.get();
      if (!d) return;
      this.lastFocus = document.activeElement;
      d.hidden = false;
      // Force a frame so the transition has a state to animate from.
      requestAnimationFrame(function () { d.classList.add('is-open'); });
      document.documentElement.classList.add('has-drawer');
      var close = d.querySelector('[data-drawer-close]:not([tabindex="-1"])');
      if (close) close.focus();
    },

    close: function () {
      var d = this.get();
      if (!d || d.hidden) return;
      d.classList.remove('is-open');
      document.documentElement.classList.remove('has-drawer');
      var finish = function () { d.hidden = true; };
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) { finish(); } else { window.setTimeout(finish, 280); }
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    },

    // Pull a fresh copy of the drawer from the server and swap it in.
    refresh: function () {
      return fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root + '?sections=cart-drawer'
          : '/?sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (json) {
          var html = json['cart-drawer'];
          if (!html) return;
          var host = document.getElementById('shopify-section-cart-drawer');
          if (!host) return;
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var fresh = parsed.getElementById('shopify-section-cart-drawer');
          host.innerHTML = fresh ? fresh.innerHTML : html;
          Drawer.root = null;
          bindDrawer();
        });
    }
  };

  function updateCount(n) {
    document.querySelectorAll('.hdr__count').forEach(function (el) {
      el.textContent = n;
      el.setAttribute('data-full', n > 0 ? 'true' : 'false');
    });
  }

  /* THE ONE-PER-CUSTOMER LINES, PUT BACK TO ONE.
   *
   * The membership and its tote render without a stepper, so the honest route
   * cannot raise them. It is still possible to arrive holding two — an older
   * cart from before this rule, the join button pressed while the membership
   * was already in, or a hand-written POST — and a cart showing "1" while
   * Shopify holds 2 would charge for two and hand out two free totes.
   *
   * So the drawer corrects rather than just displays. It asks the cart what is
   * really in it instead of trusting the markup, changes only what is wrong,
   * and refreshes once at the end. A cart that is already correct — which is
   * almost all of them — makes one GET and stops.
   */
  function capOneLines(scope) {
    if (!scope.querySelector('[data-cap-one]')) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var capped = [];
        scope.querySelectorAll('[data-cap-one]').forEach(function (el) {
          var line = Number(el.getAttribute('data-cap-one'));
          var item = cart.items[line - 1];
          /* The drawer and the cart page can both be in the document at once
             and would each nominate the same line. Fix it once. */
          if (item && item.quantity > 1 && capped.indexOf(line) === -1) capped.push(line);
        });
        if (!capped.length) return null;
        /* One at a time: /cart/change renumbers lines as it goes, so firing
           these together would aim the second change at a line that has moved. */
        return capped.reduce(function (chain, line) {
          return chain.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ line: line, quantity: 1 })
            }).then(function (r) { return r.json(); });
          });
        }, Promise.resolve()).then(function (cart2) {
          if (cart2 && typeof cart2.item_count === 'number') updateCount(cart2.item_count);
          /* The cart PAGE is server-rendered, so its totals are now stale by
             the amount that was just removed. Only a reload tells the truth.
             The drawer refreshes in place, which is cheaper and does not throw
             the reader out of whatever they were doing. */
          if (window.location.pathname.indexOf('/cart') === 0) {
            window.location.reload();
            return null;
          }
          return Drawer.refresh();
        });
      })
      .catch(function () { /* a cart that will not answer is not worth breaking the drawer over */ });
  }

  /* THE MEMBERSHIP AND ITS TOTE LEAVE TOGETHER.
   *
   * The tote is priced at zero because it is the gift attached to a membership.
   * A cart holding the tote and no membership is a free bag, so removing the
   * membership has to take the tote with it — and the reverse, because the two
   * are one decision rather than two lines that happen to be adjacent.
   *
   * By VARIANT ID through /cart/update.js, not by line index: /cart/change
   * renumbers lines as it goes, so removing two by index sends the second at
   * whatever moved into the gap.
   */
  function bindClubRemove(scope) {
    scope.querySelectorAll('[data-club-remove]').forEach(function (el) {
      if (el.dataset.clubBound) return;
      el.dataset.clubBound = '1';
      el.addEventListener('click', function (e) {
        e.preventDefault();
        var ids = (el.getAttribute('data-club-remove') || '').split(',').filter(Boolean);
        /* No ids means the markup could not name the pair. The href still
           points at Shopify's own remove URL, so let the click through rather
           than swallow it and leave the reader with a dead control. */
        if (!ids.length) { if (el.href) window.location.href = el.href; return; }
        var updates = {};
        ids.forEach(function (id) { updates[id] = 0; });
        el.setAttribute('aria-busy', 'true');
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateCount(cart.item_count);
            if (window.location.pathname.indexOf('/cart') === 0) {
              window.location.reload();
              return null;
            }
            return Drawer.refresh();
          })
          .catch(function () { el.removeAttribute('aria-busy'); });
      });
    });
  }

  function bindDrawer() {
    var d = Drawer.get();
    if (!d) return;

    d.querySelectorAll('[data-drawer-close]').forEach(function (b) {
      b.addEventListener('click', function () { Drawer.close(); });
    });

    capOneLines(d);
    bindClubRemove(d);

    d.querySelectorAll('[data-qty-change]').forEach(function (b) {
      b.addEventListener('click', function () {
        var line = b.getAttribute('data-qty-change');
        var to = b.getAttribute('data-qty-to');
        b.disabled = true;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: Number(line), quantity: Number(to) })
        })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateCount(cart.item_count);
            return Drawer.refresh();
          })
          .catch(function () { b.disabled = false; });
      });
    });
  }

  // Escape closes from anywhere, and focus stays inside while it is open.
  function bindGlobalDrawerKeys() {
    document.addEventListener('keydown', function (e) {
      var d = Drawer.get();
      if (!d || d.hidden) return;

      if (e.key === 'Escape') { Drawer.close(); return; }
      if (e.key !== 'Tab') return;

      var panel = d.querySelector('[data-drawer-panel]');
      if (!panel) return;
      var focusables = panel.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];

      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ── adding to the cart ──────────────────────────────────────────────────
     Never costs the customer the page they were shopping. */
  function bindAddForms() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      /* Klaviyo wants E.164 and people type what they type. A number already
     carrying its country code is kept; a bare ten digits is North American,
     which is where this shop and its round are; eleven starting with a 1 is
     the same number written another way. Anything else is handed back rather
     than guessed at — a wrong country code is a number that silently never
     receives anything. */
  function phoneOf(v) {
    var d = String(v).replace(/[^\d+]/g, '');
    if (d.charAt(0) === '+') return /^\+\d{8,15}$/.test(d) ? d : null;
    if (/^\d{10}$/.test(d)) return '+1' + d;
    if (/^1\d{10}$/.test(d)) return '+' + d;
    return null;
  }

  form.addEventListener('submit', function (e) {
        if (!window.fetch) return;

        // Shopify's accelerated checkout buttons submit this same form. Only
        // intercept our own add button — hijacking the rest would break Shop
        // Pay and take the fastest route to purchase off the page.
        if (e.submitter && !e.submitter.hasAttribute('data-add')) return;

        e.preventDefault();

        var btn = form.querySelector('[data-add]');
        var err = form.querySelector('[data-add-error]');
        if (err) err.hidden = true;
        if (btn) btn.disabled = true;

        /* TWO LINES IN ONE CALL. A form posts one item; the club needs the
           membership AND the gift that comes with it, and two sequential adds
           give a visible flash of a half-built cart plus a second failure
           point. data-also names the companion variant and the whole thing
           goes as one items[] payload.

           The properties are carried across by hand because FormData names
           them properties[Gift] and the JSON API wants a properties object —
           dropping them would lose the note that tells the packer what to put
           in the box. */
        /* THE TICK UNDER THE BUTTON. If somebody asked for the membership on
           their way past, the garment and the membership go in together — one
           call, one cart, no half-built state. It reuses data-also's items[]
           path rather than growing a second one: the club page adds a
           membership plus a gift, this adds a garment plus a membership plus
           the same gift, and they are the same shape. */
        var join = form.querySelector('[data-join]:checked');
        var also = form.getAttribute('data-also');
        var fd = new FormData(form);
        var req = { method: 'POST', body: fd };
        if (join) {
          var extra = [{
            id: join.getAttribute('data-join-variant'),
            quantity: 1
          }];
          if (join.getAttribute('data-join-plan')) {
            extra[0].selling_plan = join.getAttribute('data-join-plan');
          }
          if (join.getAttribute('data-join-gift')) {
            extra.push({
              id: join.getAttribute('data-join-gift'),
              quantity: 1,
              properties: { _club_gift: '1' }
            });
          }
          var mine = { id: fd.get('id'), quantity: Number(fd.get('quantity') || 1) };
          if (fd.get('selling_plan')) mine.selling_plan = fd.get('selling_plan');
          req = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [mine].concat(extra) })
          };
        } else if (also) {
          var item = { id: fd.get('id'), quantity: 1 };
          if (fd.get('selling_plan')) item.selling_plan = fd.get('selling_plan');
          var props = {};
          fd.forEach(function (v, k) {
            var m = k.match(/^properties\[(.+)\]$/);
            if (m) props[m[1]] = v;
          });
          if (Object.keys(props).length) item.properties = props;
          req = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            /* _club_gift MARKS THE LINE SO IT CAN BE TAKEN BACK. The gift is
               only a gift while the membership is in the cart beside it —
               remove the membership and this has to go too, or somebody
               checks out with a free tote and no subscription. Underscored so
               Shopify hides it from the customer and the order. */
            body: JSON.stringify({
              items: [item, { id: also, quantity: 1, properties: { _club_gift: '1' } }]
            })
          };
        }

        fetch('/cart/add.js', req)
          .then(function (r) {
            if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message); });
            return r.json();
          })
          .then(function () {
            return fetch('/cart.js').then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            updateCount(cart.item_count);
            return Drawer.refresh();
          })
          .then(function () {
            Drawer.open();
            if (btn) btn.disabled = false;
          })
          .catch(function (ex) {
            if (btn) btn.disabled = false;
            if (err) { err.textContent = ex.message || 'Something went wrong.'; err.hidden = false; }
          });
      });
    });
  }

  // The header cart link opens the drawer instead of navigating, but only
  // once there is a drawer to open.
  function bindCartLinks() {
    document.querySelectorAll('a[href$="/cart"], a[href*="/cart?"]').forEach(function (a) {
      if (a.closest('[data-drawer]')) return;
      a.addEventListener('click', function (e) {
        if (!window.fetch || !Drawer.get()) return;
        e.preventDefault();
        Drawer.refresh().then(function () { Drawer.open(); });
      });
    });
  }

  /* ── buying from the grid ────────────────────────────────────────────────
     Delegated, so cards rendered later are covered without rebinding. The
     button reports its own busy state rather than blocking the whole page. */
  function bindQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-add-variant]') : null;
      if (!btn || btn.disabled || !window.fetch) return;

      e.preventDefault();
      var id = btn.getAttribute('data-add-variant');
      if (!id) return;

      var soldOut = false;
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(id), quantity: 1 })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message); });
          return r.json();
        })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          updateCount(cart.item_count);
          return Drawer.refresh();
        })
        .then(function () { Drawer.open(); })
        .catch(function () {
          // A size can sell out between page load and click. Leave the label
          // intact and put the control into the same disabled state it would
          // have had on load, rather than blanking what the shopper pressed.
          soldOut = true;
          btn.setAttribute('aria-disabled', 'true');
        })
        .then(function () {
          btn.removeAttribute('aria-busy');
          btn.disabled = soldOut;
        });
    });
  }

  /* ── arriving ────────────────────────────────────────────────────────────
     Chapters settle as they are reached. The hidden state is applied by this
     script rather than sitting in the stylesheet, so if the script never runs
     the page is simply visible — content is never hidden by CSS that has no
     way of being undone. */
  // Sorting submits on change; the form still works without this.
  function bindSort() {
    document.querySelectorAll('[data-sort]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var form = sel.closest('[data-sort-form]');
        if (form) form.submit();
      });
    });
  }

  /* ONE PANEL AT A TIME. The filter and sort panels float over the grid, so
     two open at once land on top of each other. <details> has no idea its
     siblings exist; this tells it. Nothing here is load-bearing — with the
     script off the panels open inline-stacked and stay readable. */
  function bindBar() {
    document.querySelectorAll('[data-sort-form]').forEach(function (bar) {
      var panels = Array.prototype.slice.call(bar.querySelectorAll('details.filt'));
      panels.forEach(function (d) {
        /* The stylesheet leaves these inline. Floating is earned here, at the
           moment the disclosure gains a way of being closed again. */
        d.classList.add('filt--pop');
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          panels.forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
      /* And a click anywhere else closes the lot, which is what every other
         menu on the web does and therefore what a hand expects. */
      document.addEventListener('click', function (e) {
        panels.forEach(function (d) {
          if (d.open && !d.contains(e.target)) d.open = false;
        });
      });
      bar.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        panels.forEach(function (d) { d.open = false; });
      });
    });
  }

  function init() {
    var pdp = document.querySelector('[data-pdp]');
    if (pdp) bindProduct(pdp);

    /* A colorway swap replaces the product markup, which takes the variant
       bindings with it. Re-bind against the new DOM rather than leaving a page
       whose size radios do nothing. */
    document.addEventListener('wwd:pdp-swapped', function () {
      var fresh = document.querySelector('[data-pdp]');
      if (fresh) bindProduct(fresh);
      bindAddForms();
    });
    bindDrawer();
    /* The cart PAGE has capped lines too, and it has no drawer to bind. Run it
       once over the whole document on load so both surfaces self-correct. */
    capOneLines(document);
    bindClubRemove(document);
    bindGlobalDrawerKeys();
    bindAddForms();
    bindCartLinks();
    bindQuickAdd();
    bindSort();
    bindBar();
    bindJoinFromCart();
    reconcileClubGift();
  }

  /* ── JOINING FROM THE CART ───────────────────────────────────────────────
     The second chance. Somebody who ignored the tick on the product page is
     now looking at a total, which is the moment a percentage off it means the
     most. One press adds the membership and its gift to the cart they are
     already holding.

     Delegated from the document, because the drawer repaints itself after
     every change and anything bound to its innards dies with the repaint. */
  function bindJoinFromCart() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-join-add]');
      if (!b) return;
      e.preventDefault();
      if (b.disabled) return;
      b.disabled = true;

      var items = [{ id: b.getAttribute('data-join-variant'), quantity: 1 }];
      if (b.getAttribute('data-join-plan')) {
        items[0].selling_plan = b.getAttribute('data-join-plan');
      }
      if (b.getAttribute('data-join-gift')) {
        items.push({
          id: b.getAttribute('data-join-gift'),
          quantity: 1,
          properties: { _club_gift: '1' }
        });
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message); });
          return r.json();
        })
        .then(function () {
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          updateCount(cart.item_count);
          /* The prices on this page were calculated without the membership in
             the cart, so every one of them is now wrong. The drawer can
             repaint; the cart page has to come back for fresh totals. */
          if (/\/cart(\/|$|\?)/.test(window.location.pathname)) window.location.reload();
          else Drawer.refresh();
        })
        .catch(function () { b.disabled = false; });
    });
  }

  /* ── THE GIFT DOES NOT OUTLIVE THE MEMBERSHIP ────────────────────────────
     The tote goes in as a second line at $0, and it is only free because a
     discount is looking at the membership sitting next to it. Take the
     membership out and the tote is a real product at $48 that somebody is
     about to be charged for — or worse, one the discount still zeroes and we
     ship for nothing.

     RECONCILED ON EVERY PAGE, NOT HOOKED TO A BUTTON. There are four ways to
     remove a line — the drawer's minus, the cart page's quantity field, its
     remove link, and the back button landing on a stale page — and hanging
     this off any one of them leaves the other three broken. Reading the cart
     once on load covers all of them, including carts changed in another tab.

     It only ever removes; it never adds the tote back. Somebody who
     deliberately deleted the gift and kept the membership meant it. */
  var CLUB_PRODUCT_ID = 10913324269879; // the-garden-club, subscription only

  function reconcileClubGift() {
    if (!window.fetch) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var hasClub = items.some(function (i) { return i.product_id === CLUB_PRODUCT_ID; });
        if (hasClub) return null;

        var orphans = items.filter(function (i) {
          return i.properties && i.properties._club_gift;
        });
        if (!orphans.length) return null;

        /* By key rather than by index: removing one line renumbers the rest,
           so a second removal by index takes the wrong thing. */
        return orphans.reduce(function (chain, line) {
          return chain.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: line.key, quantity: 0 })
            });
          });
        }, Promise.resolve()).then(function () { return true; });
      })
      .then(function (removed) {
        if (!removed) return;
        /* The cart page is server-rendered and now shows a line that is gone.
           The drawer can repaint itself; the page has to come back. */
        if (/\/cart(\/|$|\?)/.test(window.location.pathname)) window.location.reload();
        else Drawer.refresh();
      })
      .catch(function () { /* a cart we could not read is not a cart to edit */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ── the turn ───────────────────────────────────────────────────────────────
   Wipes the community across the shop, bound to scroll position and never to
   a clock. A hard vertical edge crosses right to left, holds while you are
   inside it, then keeps travelling the same way until it has gone — and the
   shop is still underneath, unchanged.

   Both phases move the edge leftward on purpose. A panel that arrives and
   then reverses reads as a drawer; one that keeps going reads as a pass.

   With this blocked the CSS leaves the classy face showing, which is a
   finished, working commerce section. Nothing here is load-bearing. */
(function () {
  var turns = [].slice.call(document.querySelectorAll('[data-turn]'));
  if (!turns.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var ticking = false;

  function frame() {
    ticking = false;
    var vh = window.innerHeight;

    for (var i = 0; i < turns.length; i++) {
      var el = turns[i];
      var rules = el.querySelector('.turn__rules');
      if (!rules) continue;

      var r = el.getBoundingClientRect();
      var travel = r.height - vh;
      if (travel <= 0) continue;

      var p = (-r.top) / travel;
      p = p < 0 ? 0 : p > 1 ? 1 : p;

      var wl = 100, wr = 0;
      if (p < 0.34) {
        wl = (1 - p / 0.34) * 100;            /* sweeping in from the right */
      } else if (p < 0.66) {
        wl = 0;                                /* held — you are in the room */
      } else {
        wl = 0;
        wr = ((p - 0.66) / 0.34) * 100;       /* sweeping out, same direction */
      }

      /* on the SECTION, so either face can read them — a flipped turn clips
         the classy face with the very same numbers */
      el.style.setProperty('--wl', wl.toFixed(2) + '%');
      el.style.setProperty('--wr', wr.toFixed(2) + '%');

      /* A clipped face is still "on screen" as far as IntersectionObserver is
         concerned, so anything that plays on arrival would finish behind the
         shop and be over before the reader ever saw it. The wipe is the only
         thing that knows when a face is genuinely open. */
      /* Fully open, which is the opposite thing on a flipped turn: there the
         loud face is what you land on and the plate is what covers it, so the
         room is open at both ENDS of the pass and shut in the middle. Read the
         wrong way round, every arrival would play behind the plate. */
      var open = el.hasAttribute('data-flip')
        ? (wl >= 100 || wr >= 100)
        : (wl === 0 && wr === 0);
      if (open !== (rules.dataset.open === '1')) {
        rules.dataset.open = open ? '1' : '0';
        rules.dispatchEvent(new CustomEvent('wwd:face', {
          bubbles: true, detail: { open: open },
        }));
      }
    }
  }

  function kick() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
  addEventListener('scroll', kick, { passive: true });
  addEventListener('resize', kick, { passive: true });
  frame();
})();

/* ── the atlas ──────────────────────────────────────────────────────────────
   The dots land when the community face has actually arrived — not on page
   load, because nothing should move before the customer does. Then the
   readout walks the places, largest first, and holds each one open.

   Until somebody takes over. A cursor hovering a dot, a thumb on a dot, a
   thumb on a row of the list: any of those stop the cycle for good. A panel
   that keeps changing under a reader who has just chosen something is
   arguing with them.

   It also stops the moment the face leaves. A counter still ticking behind a
   color panel nobody is looking at is a page talking to itself. */
(function () {
  var faces = [].slice.call(document.querySelectorAll('.turn__rules'));

  faces.forEach(function (face) {
    var dots = [].slice.call(face.querySelectorAll('[data-atlas-dot]'));
    var read = face.querySelector('[data-atlas-read]');
    if (!dots.length || !read) return;

    var list = face.querySelector('[data-places]');
    var rows = list ? [].slice.call(list.children) : [];
    var big = read.querySelector('b');
    var lab = read.querySelector('i');
    var of = read.querySelector('span');
    var hint = of ? of.textContent : '';
    var at = -1, timer = null, live = false, taken = false;

    var order = dots.slice().sort(function (a, b) {
      return (+b.dataset.n || 0) - (+a.dataset.n || 0);
    });
    /* the markup is in whatever order the data arrived; the reading is by size */
    rows.sort(function (a, b) { return (+b.dataset.n || 0) - (+a.dataset.n || 0); })
      .forEach(function (li) { list.appendChild(li); });

    /* which row belongs to which dot, by label — the two lists are built from
       the same places but neither knows about the other */
    var rowOf = {};
    rows.forEach(function (li) { rowOf[li.dataset.place] = li; });

    function show(i) {
      if (order[at]) {
        order[at].classList.remove('is-on');
        var was = rowOf[order[at].dataset.lab];
        if (was) was.classList.remove('is-on');
      }
      at = i;
      var d = order[at];
      d.classList.add('is-on');
      var li = rowOf[d.dataset.lab];
      if (li) li.classList.add('is-on');
      big.textContent = d.dataset.n;
      lab.textContent = d.dataset.lab;
      if (of) {
        var pct = +d.dataset.pct || 0;
        of.textContent = 'people here · ' + (pct < 1 ? 'under 1%' : pct + '%') + ' of everyone';
      }
    }
    function step() { show((at + 1) % order.length); }

    function take(el) {
      var i = order.indexOf(el);
      if (i < 0) return;
      taken = true;
      if (timer) { clearInterval(timer); timer = null; }
      show(i);
    }

    dots.forEach(function (d) {
      var hold = function () { take(d); };
      d.addEventListener('mouseenter', hold);
      d.addEventListener('click', hold);
      d.addEventListener('focus', hold);
      d.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); hold(); }
      });
    });
    rows.forEach(function (li) {
      li.querySelector('.places__b').addEventListener('click', function () {
        var d = order.filter(function (x) { return x.dataset.lab === li.dataset.place; })[0];
        if (d) take(d);
      });
    });

    function start() {
      if (live) return;
      live = true;
      face.classList.add('is-live');
      if (taken) return;
      /* the biggest place is called out as soon as it has landed, not after
         every dot has — waiting for the tail makes the panel feel broken */
      setTimeout(function () {
        if (!live || taken) return;
        step();
        timer = setInterval(step, 1800);
      }, 700);
    }
    function stop() {
      live = false;
      if (timer) { clearInterval(timer); timer = null; }
    }

    if (!('IntersectionObserver' in window)) { start(); return; }
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { e.isIntersecting ? start() : stop(); });
    }, { threshold: 0.35 }).observe(face);

    if (of) of.textContent = hint;
  });
})();

/* ── the swipe ───────────────────────────────────────────────────────────────
   The break-the-rules faces are horizontal. The scroller itself is native, so
   a thumb works with no script at all; this only adds the dashes that say how
   far along you are and the arrows a mouse needs.

   Built from the panels that are actually there, so the markup stays the one
   source of truth about how many there are. */
(function () {
  [].slice.call(document.querySelectorAll('[data-swipe]')).forEach(function (swipe) {
    var panels = [].slice.call(swipe.children);
    var bar = swipe.parentNode.querySelector('.swipe__bar');
    if (!bar) return;
    /* one panel is not a rail: the dots and the word SWIPE would be telling a
       reader to do something there is nothing to do */
    if (panels.length < 2) { bar.hidden = true; return; }

    var dots = bar.querySelector('[data-swipe-dots]');
    var prev = bar.querySelector('[data-swipe-prev]');
    var next = bar.querySelector('[data-swipe-next]');
    var at = 0;

    panels.forEach(function (p, i) {
      var li = document.createElement('li');
      li.className = i ? '' : 'is-on';
      dots.appendChild(li);
    });

    function to(i) {
      i = Math.max(0, Math.min(panels.length - 1, i));
      swipe.scrollTo({ left: panels[i].offsetLeft - panels[0].offsetLeft, behavior: 'smooth' });
    }
    function mark() {
      /* which panel is nearest the middle — snap points can settle a pixel or
         two off, and rounding on scrollLeft alone drifts by the last panel */
      var mid = swipe.scrollLeft + swipe.clientWidth / 2;
      var best = 0, gap = Infinity;
      panels.forEach(function (p, i) {
        var c = p.offsetLeft - panels[0].offsetLeft + p.offsetWidth / 2;
        var d = Math.abs(c - mid);
        if (d < gap) { gap = d; best = i; }
      });
      if (best === at) return;
      at = best;
      [].slice.call(dots.children).forEach(function (li, i) {
        li.classList.toggle('is-on', i === at);
      });
      if (prev) prev.disabled = at === 0;
      if (next) next.disabled = at === panels.length - 1;
    }

    if (prev) { prev.disabled = true; prev.addEventListener('click', function () { to(at - 1); }); }
    if (next) next.addEventListener('click', function () { to(at + 1); });

    var tick = null;
    swipe.addEventListener('scroll', function () {
      if (tick) return;
      tick = requestAnimationFrame(function () { tick = null; mark(); });
    }, { passive: true });
    mark();
  });
})();

/* ── the crate ──────────────────────────────────────────────────────────────
   One record plays at a time, across every crate on the page. Nothing starts
   on its own — a site that makes noise at you before you ask has taken
   something from you. */
(function () {
  var plays = [].slice.call(document.querySelectorAll('[data-track]'));
  if (!plays.length) return;

  var audio = new Audio();
  var now = null;

  function mmss(s) {
    s = Math.max(0, Math.floor(s || 0));
    return Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2);
  }
  function paint() {
    plays.forEach(function (b) {
      var on = b === now && !audio.paused;
      b.classList.toggle('is-on', on);
      var w = b.querySelector('[data-word]');
      if (w) w.textContent = on ? w.dataset.pause : w.dataset.play;
      var panel = b.closest('.swipe__p');
      if (!panel) return;
      var disc = panel.querySelector('[data-disc]');
      if (disc) disc.classList.toggle('is-on', on);
      if (b !== now) {
        var p0 = panel.querySelector('[data-prog]');
        var t0 = panel.querySelector('[data-elapsed]');
        if (p0) p0.style.width = '0%';
        if (t0) t0.textContent = '0:00';
      }
    });
  }

  plays.forEach(function (b) {
    b.addEventListener('click', function () {
      if (now === b) {
        audio.paused ? audio.play() : audio.pause();
      } else {
        now = b;
        audio.src = b.dataset.track;
        audio.play();
      }
      paint();
    });
  });

  /* ── carrying the record across a page load ───────────────────────────
     A Shopify theme is many documents: clicking SHOP destroys this Audio
     object and builds a new one. Nothing can keep sound running across that
     — the only thing that can is never unloading the document, which means
     client-side navigation, which means re-initialising every app on the
     page. Not a trade worth making for a record.

     What IS fixable is the part that felt broken: it came back at 0:00. The
     position was only ever stashed on play, pause and ended, so whatever was
     saved was the moment somebody last pressed something, not where the
     needle actually was. It is saved as it moves now, and on pagehide.

     And it resumes on the first touch of the new page rather than needing
     somebody to find the disc: browsers refuse play() without a gesture, so
     this waits for one and spends it. Any tap, anywhere, once. */
  var KEEP = 'wwd.crate.at';
  var stash = function () {
    if (!now) return;
    try {
      sessionStorage.setItem(KEEP, JSON.stringify({
        src: now.dataset.track, t: audio.currentTime, playing: !audio.paused,
      }));
    } catch (e) {}
  };
  var lastSave = 0;
  audio.addEventListener('timeupdate', function () {
    var n = Date.now();
    if (n - lastSave > 1000) { lastSave = n; stash(); }
  });
  ['play', 'pause', 'ended'].forEach(function (e) { audio.addEventListener(e, stash); });
  window.addEventListener('pagehide', stash);

  var resume = function () { var p = audio.play(); if (p && p.catch) p.catch(function () {}); };
  (function restore() {
    var was;
    try { was = JSON.parse(sessionStorage.getItem(KEEP)); } catch (e) { return; }
    if (!was || !was.src) return;
    var b = plays.filter(function (x) { return x.dataset.track === was.src; })[0];
    if (!b) return;

    /* Cued, not played. The record is on the deck at the right groove and the
       header says so; no sound has been made without being asked for. */
    now = b;
    audio.src = was.src;

    /* SEEK BEFORE SOUND, NOT ALONGSIDE IT. currentTime cannot be set until
       the browser knows how long the file is, and on a phone the first touch
       — which is usually a scroll — arrives long before an mp3 over the
       network has its metadata. play() then started at 0:00 and the seek
       landed a moment later, which is exactly the "it started from the
       beginning" that was reported: it did, briefly.

       So a resume asked for early is REMEMBERED and spent the moment the
       file is ready, rather than issued into a track that has no duration. */
    var want = was.t || 0;
    var seated = false;
    var wantPlay = false;
    function seat() {
      if (seated) return;
      try { audio.currentTime = want; seated = true; } catch (e) { return; }
      if (wantPlay) { wantPlay = false; var p = audio.play(); if (p && p.catch) p.catch(function () {}); }
    }
    if (audio.readyState >= 1) seat();
    else audio.addEventListener('loadedmetadata', seat, { once: true });
    resume = function () {
      if (seated) { var p = audio.play(); if (p && p.catch) p.catch(function () {}); }
      else { wantPlay = true; audio.load(); }
    };
    paint();
    document.dispatchEvent(new CustomEvent('wwd:playing', { detail: {
      playing: false, name: b.dataset.name, src: was.src, t: was.t || 0,
    } }));

    if (!was.playing) return;
    var spend = function () {
      document.removeEventListener('pointerdown', spend, true);
      document.removeEventListener('keydown', spend, true);
      resume();
    };
    document.addEventListener('pointerdown', spend, true);
    document.addEventListener('keydown', spend, true);
  })();

  audio.addEventListener('timeupdate', function () {
    if (!now) return;
    var panel = now.closest('.swipe__p');
    if (!panel) return;
    var p = panel.querySelector('[data-prog]');
    var t = panel.querySelector('[data-elapsed]');
    if (p && audio.duration) p.style.width = (audio.currentTime / audio.duration) * 100 + '%';
    if (t) t.textContent = mmss(audio.currentTime);
  });
  /* The header transport does not own the audio — it asks. One element, one
     owner, and the corner of the page cannot get out of step with the crate. */
  document.addEventListener('wwd:control', function (e) {
    var what = e.detail && e.detail.action;
    if (what === 'next') {
      var i = plays.indexOf(now);
      var b = plays[(i + 1 + plays.length) % plays.length];
      if (b) b.click();
      return;
    }
    if (!now) { if (plays[0]) plays[0].click(); return; }
    audio.paused ? audio.play() : audio.pause();
    paint();
  });

  /* ONE RECORD ENDS, THE NEXT ONE STARTS — and nothing else changes about
     when sound begins. The rule at the top of this block still holds: nothing
     plays on its own. `ended` cannot fire unless somebody pressed play, so
     continuing is finishing the thing they asked for rather than starting
     something they did not.

     It wraps, the same way the skip button does. Two controls that both mean
     "the next one" should not disagree about what happens after the last one.

     The click is deliberate rather than setting audio.src here: the track
     button already owns choosing a record — the artwork, the progress bar and
     the label all follow from it — and a second path to the same state is a
     second place for them to fall out of step. */
  audio.addEventListener('ended', function () {
    if (!now || plays.length < 2) return;
    var i = plays.indexOf(now);
    var b = plays[(i + 1) % plays.length];
    if (b) b.click();
  });

  ['play', 'pause', 'ended'].forEach(function (e) {
    audio.addEventListener(e, function () {
      paint();
      document.dispatchEvent(new CustomEvent('wwd:playing', { detail: {
        playing: !audio.paused,
        name: now ? now.dataset.name : null,
        src: now ? now.dataset.track : null,
        t: audio.currentTime,
      } }));
    });
  });
})();

/* ── the needle ─────────────────────────────────────────────────────────────
   The chrome player, and the honest note about it: a Shopify theme is many
   documents, so this element is destroyed and rebuilt on every navigation.
   Track and position are stashed so the bar comes back where it was, but the
   sound stops at the click. Resuming needs the browser's permission, which on
   iOS Safari means another tap, every time. */
(function () {
  var bar = document.querySelector('[data-needle]');
  if (!bar) return;

  var list;
  try { list = JSON.parse(bar.querySelector('[data-ndl-list]').textContent); }
  catch (e) { return; }
  if (!list.length) return;

  var KEY = 'wwd.needle';
  var save = function (s) { try { sessionStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {} };
  var load = function () {
    try { return JSON.parse(sessionStorage.getItem(KEY)) || {}; } catch (e) { return {}; }
  };

  var was = load();
  if (was.closed) return;

  var at = Math.min(list.length - 1, Math.max(0, was.at || 0));
  var audio = new Audio();
  var name = bar.querySelector('[data-ndl-name]');
  var who = bar.querySelector('[data-ndl-artist]');
  var prog = bar.querySelector('[data-ndl-prog]');

  function cue(i, seek) {
    at = (i + list.length) % list.length;
    audio.src = list[at].src;
    if (seek) audio.currentTime = seek;
    name.textContent = list[at].name;
    who.textContent = list[at].artist;
    save({ at: at, t: seek || 0, playing: !audio.paused });
  }

  bar.hidden = false;
  requestAnimationFrame(function () { bar.classList.add('is-up'); });
  cue(at, was.t);

  bar.querySelector('[data-ndl-toggle]').addEventListener('click', function () {
    audio.paused ? audio.play() : audio.pause();
  });
  bar.querySelector('[data-ndl-next]').addEventListener('click', function () {
    var going = !audio.paused;
    cue(at + 1);
    if (going) audio.play();
  });
  bar.querySelector('[data-ndl-close]').addEventListener('click', function () {
    audio.pause();
    save({ closed: true });
    bar.classList.remove('is-up');
  });

  audio.addEventListener('ended', function () { cue(at + 1); audio.play(); });
  audio.addEventListener('timeupdate', function () {
    if (audio.duration) prog.style.width = (audio.currentTime / audio.duration) * 100 + '%';
  });
  ['play', 'pause'].forEach(function (e) {
    audio.addEventListener(e, function () {
      bar.classList.toggle('is-playing', !audio.paused);
      save({ at: at, t: audio.currentTime, playing: !audio.paused });
    });
  });
  window.addEventListener('pagehide', function () {
    save({ at: at, t: audio.currentTime, playing: !audio.paused });
  });

  /* The attempt, so the failure is measured rather than assumed. */
  if (was.playing) {
    var p = audio.play();
    if (p && p.catch) p.catch(function () { bar.dataset.blocked = '1'; });
  }
})();

/* ── on our feet ────────────────────────────────────────────────────────────
   Same contract as the atlas: hover on a pointer, tap on a thumb, and the
   readout says what you touched. No cycle here — a palette is already the
   whole picture at a glance, so nothing needs to walk you through it. */
(function () {
  [].slice.call(document.querySelectorAll('[data-hues]')).forEach(function (field) {
    var read = field.parentNode.querySelector('[data-hue-read]');
    if (!read) return;
    var big = read.querySelector('b');
    var lab = read.querySelector('i');
    var of = read.querySelector('span');
    var hint = of ? of.textContent : '';
    var swatches = [].slice.call(field.querySelectorAll('[data-hue]'));

    function show(b) {
      swatches.forEach(function (x) { x.parentNode.classList.toggle('is-on', x === b); });
      big.textContent = b.dataset.n;
      lab.textContent = b.dataset.name;
      if (of) {
        var p = +b.dataset.pct || 0;
        of.textContent = 'times thrown · ' + (p < 1 ? 'under 1%' : p + '%') + ' of every color';
      }
    }
    swatches.forEach(function (b) {
      ['mouseenter', 'click', 'focus'].forEach(function (e) {
        b.addEventListener(e, function () { show(b); });
      });
    });
    if (of) of.textContent = hint;
  });
})();


/* ── the route ──────────────────────────────────────────────────────────────
   Somebody's activity, drawn.

   The shape comes from Strava's `map.summary_polyline`, which is Google's
   encoded-polyline format, so the decoder below is the real one rather than a
   stand-in. No tile server, no map provider, no key: the route IS the
   picture, and the only thing on screen is the line somebody moved along.

   WHERE IT CAN COME FROM. Not the club feed — that endpoint returns a name,
   a sport and a distance and nothing else, no coordinates at all. A route
   needs the member's own connection. Nobody appears here who did not switch
   it on themselves. */
(function () {
  function decode(str) {
    var pts = [], i = 0, lat = 0, lon = 0;
    while (i < str.length) {
      for (var k = 0; k < 2; k++) {
        var r = 0, sh = 0, b;
        do { b = str.charCodeAt(i++) - 63; r |= (b & 0x1f) << sh; sh += 5; } while (b >= 0x20);
        var d = (r & 1) ? ~(r >> 1) : (r >> 1);
        if (k === 0) lat += d; else lon += d;
      }
      pts.push([lat / 1e5, lon / 1e5]);
    }
    return pts;
  }

  /* Latitude and longitude are not the same distance apart on the ground, so
     longitude is squeezed by cos(lat) before fitting — without it every route
     comes out stretched sideways and nothing looks like the place it was. */
  function fit(pts, box, pad) {
    var s = Math.cos(pts[0][0] * Math.PI / 180);
    var xy = pts.map(function (p) { return [p[1] * s, p[0]]; });
    var xs = xy.map(function (p) { return p[0]; });
    var ys = xy.map(function (p) { return p[1]; });
    var x0 = Math.min.apply(null, xs), x1 = Math.max.apply(null, xs);
    var y0 = Math.min.apply(null, ys), y1 = Math.max.apply(null, ys);
    var w = x1 - x0 || 1e-6, h = y1 - y0 || 1e-6;
    var k = Math.min((box - pad * 2) / w, (box - pad * 2) / h);
    var ox = (box - w * k) / 2, oy = (box - h * k) / 2;
    return xy.map(function (p) {
      /* y is flipped: north is up on a map and down in an SVG */
      return [(p[0] - x0) * k + ox, box - ((p[1] - y0) * k + oy)];
    });
  }

  [].slice.call(document.querySelectorAll('[data-route]')).forEach(function (box) {
    var set = [].slice.call(box.querySelectorAll('[data-line]'));
    if (!set.length) return;
    var ghost = box.querySelector('[data-route-ghost]');
    var live = box.querySelector('[data-route-live]');
    var head = box.querySelector('[data-route-head]');
    var read = box.parentNode.querySelector('[data-route-read]');
    var oType = read && read.querySelector('[data-route-type]');
    var oWho = read && read.querySelector('[data-route-who]');
    var oMeta = read && read.querySelector('[data-route-meta]');

    var at = -1, raf = null, going = false;

    function draw(i) {
      at = i;
      var t = set[at];
      var pts;
      try { pts = decode(t.dataset.poly); } catch (e) { return; }
      if (pts.length < 2) return;
      var d = 'M ' + fit(pts, 100, 7).map(function (p) {
        return p[0].toFixed(2) + ' ' + p[1].toFixed(2);
      }).join(' L ');

      ghost.setAttribute('d', d);
      live.setAttribute('d', d);
      box.dataset.type = (t.dataset.type || '').toLowerCase();
      if (oType) oType.textContent = t.dataset.type;
      if (oWho) oWho.textContent = t.dataset.who;
      if (oMeta) oMeta.textContent = t.dataset.mi + ' mi · ' + t.dataset.ago;

      var len = live.getTotalLength();
      live.style.strokeDasharray = len;
      live.style.strokeDashoffset = len;

      var t0 = null, span = 2600 + Math.min(1800, len * 6);
      cancelAnimationFrame(raf);
      (function step(now) {
        if (t0 === null) t0 = now;
        var p = Math.min(1, (now - t0) / span);
        /* ease out, so it sets off quickly and settles rather than stopping */
        var e = 1 - Math.pow(1 - p, 2.2);
        live.style.strokeDashoffset = len * (1 - e);
        var at_ = live.getPointAtLength(len * e);
        head.setAttribute('cx', at_.x);
        head.setAttribute('cy', at_.y);
        if (p < 1) raf = requestAnimationFrame(step);
        else if (going) setTimeout(function () { if (going) draw((at + 1) % set.length); }, 1400);
      })(performance.now());
    }

    function start(from) {
      if (going) return;
      going = true;
      draw(from === 0 ? 0 : (at + 1) % set.length);
    }
    function stop() { going = false; cancelAnimationFrame(raf); }

    /* Inside a turn, the wipe decides. It is the first panel now, so it must
       draw from nothing at the moment the face opens — not have finished
       behind the shop while the edge was still travelling. */
    var face = box.closest('.turn__rules');
    var wiped = face && face.closest('.turn');
    if (wiped) {
      face.addEventListener('wwd:face', function (e) {
        if (e.detail.open) { at = -1; start(0); } else { stop(); }
      });
      return;
    }

    if (!('IntersectionObserver' in window)) { start(); return; }
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { e.isIntersecting ? start() : stop(); });
    }, { threshold: 0.4 }).observe(box);
  });
})();

/* ── the key ────────────────────────────────────────────────────────────────
   The crate opens over whatever you were already reading, from a control in
   the header, on every page.

   The old bottom bar is gone and its problem is not: a Shopify theme is many
   documents, so a click to another page destroys the audio and the browser
   will not restart it without a fresh gesture. What survives is the memory of
   it — the header remembers what was playing and underlines it, and one tap
   picks it up where it stopped. That is the whole of what an MPA allows, and
   it is better than pretending. */
(function () {
  var shelf = document.querySelector('[data-shelf]');
  var key = document.querySelector('[data-shelf-open]');
  if (!shelf || !key) return;

  var label = key.querySelector('[data-shelf-now]');
  var word = label ? label.textContent : 'Music';
  var KEY = 'wwd.crate';
  var last = null;
  try { last = JSON.parse(sessionStorage.getItem(KEY)); } catch (e) {}

  var opener = null;
  function open() {
    opener = document.activeElement;
    shelf.hidden = false;
    shelf.removeAttribute('aria-hidden');
    requestAnimationFrame(function () { shelf.classList.add('is-open'); });
    key.setAttribute('aria-expanded', 'true');
    var first = shelf.querySelector('[data-play]');
    if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 340);
  }
  function close() {
    shelf.classList.remove('is-open');
    key.setAttribute('aria-expanded', 'false');
    setTimeout(function () {
      shelf.hidden = true;
      shelf.setAttribute('aria-hidden', 'true');
    }, 320);
    if (opener) opener.focus({ preventScroll: true });
  }

  key.addEventListener('click', function () {
    shelf.hidden ? open() : close();
  });
  [].slice.call(shelf.querySelectorAll('[data-shelf-close]')).forEach(function (b) {
    b.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !shelf.hidden) close();
  });

  /* What the header says, and what it remembers. */
  document.addEventListener('wwd:playing', function (e) {
    var on = e.detail && e.detail.playing;
    key.classList.toggle('is-playing', !!on);
    key.removeAttribute('data-resume');
    if (label) label.textContent = e.detail && e.detail.name ? e.detail.name : word;
    try {
      sessionStorage.setItem(KEY, JSON.stringify({
        name: e.detail && e.detail.name, src: e.detail && e.detail.src,
        t: e.detail && e.detail.t,
      }));
    } catch (err) {}
  });

  /* Arrived on a new page mid-record: say so, and offer it back. */
  if (last && last.name) {
    if (label) label.textContent = last.name;
    key.setAttribute('data-resume', '1');
    key.addEventListener('click', function once() {
      key.removeEventListener('click', once);
      var btn = shelf.querySelector('[data-track="' + last.src + '"]');
      if (btn) setTimeout(function () { btn.click(); }, 360);
    });
  }
})();


/* ── the transport ──────────────────────────────────────────────────────────
   Two buttons in the header that appear only once there is something to
   press. They do not hold the audio; they ask the crate to, so the corner of
   the page can never disagree with the record that is actually turning. */
(function () {
  var group = document.querySelector('[data-music]');
  if (!group) return;
  var say = function (action) {
    document.dispatchEvent(new CustomEvent('wwd:control', { detail: { action: action } }));
  };
  var toggle = group.querySelector('[data-music-toggle]');
  var next = group.querySelector('[data-music-next]');
  if (toggle) toggle.addEventListener('click', function () { say('toggle'); });
  if (next) next.addEventListener('click', function () { say('next'); });

  document.addEventListener('wwd:playing', function (e) {
    group.classList.add('is-live');
    group.classList.toggle('is-playing', !!(e.detail && e.detail.playing));
  });

  /* Arrived mid-record on a new page: the controls are already worth showing. */
  try {
    var was = JSON.parse(sessionStorage.getItem('wwd.crate'));
    if (was && was.name) group.classList.add('is-live');
  } catch (err) {}
})();

/* What is pinned, and when.

   The hour bar is pinned always. The transport is pinned only while something
   is playing AND the header has scrolled past it — at the top of the page it
   belongs in the header, where it started. It was fixed from the first press
   and never went back, which is the bug this answers.

   It watches the header rather than the transport, because once the transport
   goes fixed its own position stops describing where it would otherwise be. */
(function () {
  var bar = document.querySelector('.hourbar');
  if (!bar) return;
  var music = document.querySelector('[data-music]');
  var hdr = document.querySelector('.hdr');
  var root = document.documentElement;
  var hourH = 0;

  /* WHETHER SOMEBODY IS STILL LISTENING, which is not the same as whether
     sound is coming out.

     Playing: yes, obviously. Just paused: still yes for ten seconds, because
     a pause is usually a phone call or a sentence somebody wanted to read,
     and taking the play button away in that moment is taking away the only
     way back. Paused and left alone past that: no — they are done, and a
     paused transport following them down the page is furniture.

     Across a page change the test is what they were doing when they left.
     Still playing means they were listening and the browser stopped it for
     them, so the control they need is on screen. Already paused means they
     had chosen silence, and it goes back to the header where it started. */
  var LINGER = 10000;
  var listening = false;
  var letGo = null;
  try {
    var was = JSON.parse(sessionStorage.getItem('wwd.crate.at'));
    listening = !!(was && was.playing);
  } catch (e) {}

  function used() { return listening; }
  document.addEventListener('wwd:playing', function (e) {
    var on = !!(e.detail && e.detail.playing);
    if (letGo) { clearTimeout(letGo); letGo = null; }
    if (on) {
      listening = true;
      place();
      return;
    }
    /* paused — held for a moment, then handed back to the header */
    if (!listening) return;
    letGo = setTimeout(function () {
      letGo = null;
      listening = false;
      place();
    }, LINGER);
  });

  function measure() {
    hourH = Math.round(bar.offsetHeight);
    root.style.setProperty('--hour-h', hourH + 'px');
    /* the bar has to leave room for the transport whenever it is docked,
       playing or not — it takes the same height either way */
    var docked = music && music.classList.contains('is-docked');
    root.style.setProperty('--top-h',
      (hourH + (docked ? Math.round(music.offsetHeight) : 0)) + 'px');
  }

  function place() {
    if (!music || !hdr) return measure();
    /* STICKY ONCE SOMEBODY HAS PRESSED PLAY, and from then on whether it is
       playing or not.

       It used to dock only while sound was coming out, which reads as correct
       and is not: the control somebody most needs to reach is PAUSE, and the
       moment they pause it the thing they would need to un-pause it scrolled
       away with the header. Worse on a phone, where a page change stops the
       record and the browser will not restart it without a tap — so the one
       button that can bring it back has to be on screen to be tapped.

       Before anything has played it stays in the header, where it started.
       Nothing follows anybody down a page for a record they never asked for. */
    if (!used()) {
      music.classList.remove('is-docked');
      return measure();
    }
    /* The header sits ABOVE the hour bar, not below it, so at the top of the
       page anything inside the header is already higher than the bar — which
       is what made the first attempt dock instantly and never come back. The
       honest test is whether the header itself has left the screen. */
    var docked = hdr.getBoundingClientRect().bottom <= 0;
    if (docked !== music.classList.contains('is-docked')) {
      music.classList.toggle('is-docked', docked);
    }
    measure();
  }

  var ticking = false;
  function kick() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; place(); });
  }

  measure();
  place();
  addEventListener('scroll', kick, { passive: true });
  addEventListener('resize', kick, { passive: true });
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(kick);
    ro.observe(bar);
    if (music) ro.observe(music);
  }
  document.addEventListener('wwd:playing', kick);
})();

/* ── the hour ───────────────────────────────────────────────────────────────
   The shop's clock, moving.

   WHY NOT THE READER'S CITY. A browser hands over a time zone with no
   permission prompt, and the zone's name looks like a city — but it is the
   ZONE's city, not the reader's. America/New_York covers Orlando, Miami,
   Atlanta, Boston, Detroit, Charlotte and Toronto. Printing "New York" for
   all of them is not an approximation, it is a wrong fact in the one line on
   the page whose whole job is stating facts, and every reader can check it
   instantly. Real city resolution needs an IP lookup on every page load — a
   paid third party and a privacy notice — to tell somebody where they already
   are.

   So the clock is the shop's: the half of the pair the reader cannot see out
   of their own window.

   A distance from the reader used to sit at the end of this line. It was
   accurate, and it was still one fact too many for something meant to be
   read at a glance, so it is gone.

   Either clock can be chosen in theme settings; the shop's is the default. */
(function () {
  var bar = document.querySelector('[data-hour]');
  if (!bar || !window.Intl) return;

  var elTime = bar.querySelector('[data-hour-time]');
  var elDay = bar.querySelector('[data-hour-day]');
  var elNote = bar.querySelector('[data-hour-note]');

  var notes = {};
  try { notes = JSON.parse(bar.parentNode.querySelector('[data-hour-notes]').textContent); }
  catch (e) {}
  function oneOf(key) {
    var list = notes[key];
    if (!list || !list.length) return '';
    return list[Math.floor(Math.random() * list.length)];
  }

  var here;
  try { here = Intl.DateTimeFormat().resolvedOptions().timeZone; } catch (e) { here = null; }

  /* ?tz=America/Los_Angeles stands in for the reader's zone, so the line can
     be looked at as somebody on the other side of the country without
     flying there. It changes nothing for anyone who does not type it, and an
     unusable value is ignored rather than breaking the clock. */
  try {
    var asked = new URLSearchParams(location.search).get('tz');
    if (asked) {
      new Intl.DateTimeFormat([], { timeZone: asked }).format(new Date());
      here = asked;
    }
  } catch (e) {}
  var shopZone = bar.dataset.zone || here;
  var zone = bar.dataset.clock === 'reader' ? (here || shopZone) : shopZone;

  /* A zone that the merchant mistyped would throw on every tick, so it is
     tried once and the line is simply left as the server rendered it. */
  var fTime, fDay, fHour;
  try {
    fTime = new Intl.DateTimeFormat([], {
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hourCycle: 'h23', timeZone: zone,
    });
    fDay = new Intl.DateTimeFormat([], { weekday: 'long', timeZone: zone });
    fHour = new Intl.DateTimeFormat([], { hour: 'numeric', hourCycle: 'h23', timeZone: zone });
    fTime.format(new Date());
  } catch (e) { return; }

  var lastNote = null;   /* null means "whatever the server chose" */
  function paint() {
    var now = new Date();
    if (elTime) elTime.textContent = fTime.format(now);

    var h = +fHour.format(now);
    var key = h < 6 ? 'night' : h < 11 ? 'morning' : h < 17 ? 'day' : 'evening';
    var word = { night: 'Night', morning: 'Morning', day: 'Afternoon', evening: 'Evening' }[key];
    if (elDay) elDay.textContent = fDay.format(now) + ' · ' + word;

    /* The server already picked one and the page arrived showing it, so the
       first paint leaves it alone — swapping it a moment after load would
       read as a glitch. A fresh one is drawn only when the day actually turns
       over under the reader. */
    /* The inline script already settled which line this visit gets, so the
       first paint is left alone. When the day turns over the pool changes, so
       a new one is drawn and held from there. */
    if (elNote && key !== lastNote) {
      if (lastNote !== null) {
        elNote.textContent = window.wwdNote ? window.wwdNote(key, true) : oneOf(key);
      }
      lastNote = key;
    }
  }

  /* Line up with the second boundary and keep to it. setInterval drifts, and
     a throttled background tab drifts a long way, so coming back resyncs. */
  var timer = null;
  function tick() {
    paint();
    clearTimeout(timer);
    timer = setTimeout(tick, 1000 - (Date.now() % 1000));
  }
  tick();
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) tick();
  });
})();

/* ── teaser tuesday ─────────────────────────────────────────────────────────
   How long until the next one.

   Counted against the SHOP's clock, not the reader's, so everybody in the
   world is waiting for the same moment — a countdown that says four hours to
   someone in Perth and four hours to someone in Orlando is not counting to
   anything real.

   Same trick as the hour: read the shop's wall-clock back out of a formatted
   date, so daylight saving is included without a table of rules. */
(function () {
  var el = document.querySelector('[data-tease]');
  if (!el || !window.Intl) return;
  var out = el.querySelector('[data-tease-out]');
  var zone = el.dataset.zone;
  var wantDay = +el.dataset.day;
  var wantHour = +el.dataset.hour;

  var parts;
  try {
    parts = new Intl.DateTimeFormat('en-US', {
      timeZone: zone, hourCycle: 'h23', weekday: 'short',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
    });
    parts.formatToParts(new Date());
  } catch (e) { return; }

  var DAYS = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

  function shopNow() {
    var p = parts.formatToParts(new Date()).reduce(function (o, x) { o[x.type] = x.value; return o; }, {});
    return {
      dow: DAYS[p.weekday],
      h: +p.hour, m: +p.minute, s: +p.second,
    };
  }

  function left() {
    var n = shopNow();
    var days = (wantDay - n.dow + 7) % 7;
    var secs = days * 86400 + (wantHour - n.h) * 3600 - n.m * 60 - n.s;
    /* already past this week's hour — wait for the next one */
    if (secs <= 0) secs += 7 * 86400;
    return secs;
  }

  function paint() {
    var s = left();
    var d = Math.floor(s / 86400);
    var h = Math.floor((s % 86400) / 3600);
    var m = Math.floor((s % 3600) / 60);
    var sec = s % 60;
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    out.textContent = d ? d + 'd ' + pad(h) + ':' + pad(m) + ':' + pad(sec)
                        : pad(h) + ':' + pad(m) + ':' + pad(sec);
  }

  var timer = null;
  function tick() {
    paint();
    clearTimeout(timer);
    timer = setTimeout(tick, 1000 - (Date.now() % 1000));
  }
  tick();
  document.addEventListener('visibilitychange', function () { if (!document.hidden) tick(); });
})();

/* ── the list ───────────────────────────────────────────────────────────────
   Posts to Klaviyo from the browser using the PUBLIC company ID, which is what
   that endpoint is built for. The private key is not here and must never be:
   a theme is readable by anyone who views source.

   With no ID the markup is Shopify's own customer form instead and this does
   nothing, so the box works either way. */
(function () {
  /* Klaviyo pins behaviour to a dated revision. 2024-10-15 answered with
     x-klaviyo-api-retirement-date: 2026-10-15 — it stops working in October.
     2026-01-15 returns no retirement date, which is how that header reports a
     revision that is still current. */
  var K_URL = 'https://a.klaviyo.com/client/subscriptions/?company_id=';
  var K_REV = '2026-01-15';

  [].slice.call(document.querySelectorAll('[data-join]')).forEach(function (box) {
    var kid = (box.dataset.kid || '').trim();
    var form0 = box.querySelector('form');
    if (!kid) {
      /* Previewing the shape with nowhere to send it. Say so on submit rather
         than appearing to have taken the address. */
      if (form0 && !form0.action) {
        form0.addEventListener('submit', function (e) {
          e.preventDefault();
          var s = box.querySelector('[data-join-say]');
          if (s) s.textContent = 'Not connected yet — nothing was sent.';
        });
      }
      return;
    }
    var form = box.querySelector('form');
    var say = box.querySelector('[data-join-say]');
    if (!form) return;

    /* Klaviyo wants E.164 and people type what they type. A number already
     carrying its country code is kept; a bare ten digits is North American,
     which is where this shop and its round are; eleven starting with a 1 is
     the same number written another way. Anything else is handed back rather
     than guessed at — a wrong country code is a number that silently never
     receives anything. */
  function phoneOf(v) {
    var d = String(v).replace(/[^\d+]/g, '');
    if (d.charAt(0) === '+') return /^\+\d{8,15}$/.test(d) ? d : null;
    if (/^\d{10}$/.test(d)) return '+1' + d;
    if (/^1\d{10}$/.test(d)) return '+' + d;
    return null;
  }

    /* THE OTHER CHANNEL, without a second field. Swapping which input is
       present keeps the form one line long; leaving both required would fail
       validation on whichever is hidden, so required moves with it. */
    var swap = box.querySelector('[data-join-swap]');
    if (swap) {
      swap.addEventListener('click', function () {
        var tel = form.querySelector('input[name=phone]');
        var mail = form.querySelector('input[name=email]');
        if (!tel || !mail) return;
        var toMail = !tel.hidden;
        tel.hidden = toMail; tel.required = !toMail; tel.value = '';
        mail.hidden = !toMail; mail.required = toMail; mail.value = '';
        swap.textContent = swap.dataset.alt || swap.textContent;
        swap.dataset.alt = toMail ? swap.dataset.wasSms : swap.dataset.wasEmail;
        (toMail ? mail : tel).focus();
      });
      swap.dataset.wasEmail = swap.textContent;
      swap.dataset.wasSms = swap.dataset.sms || swap.textContent;
      swap.dataset.alt = swap.dataset.wasSms;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (form.querySelector('input[name=email]') || {}).value || '';
      var tel = (form.querySelector('input[name=phone]') || {}).value || '';
      email = email.trim();
      if (!email && !tel) return;

      /* SAY THE CONSENT OUT LOUD. Sending an address and a number and letting
         the endpoint infer what was agreed to records email and can leave the
         SMS channel with nothing on it — the field would collect numbers that
         could never legally be texted. Naming each channel is also what makes
         the double opt-in confirmation go out. */
      /* THE NUMBER HAS TO BE CHECKED HERE, because the endpoint will not do it
         for us. Posted on its own, "555 1234" is refused with a 400. Posted
         alongside an email it is a 202 and the number is simply gone — the
         reader is thanked, and the thing they typed was never recorded. A
         silent 202 is worse than an error, so this refuses what Klaviyo would
         have swallowed. */
      if (tel.trim()) {
        var e164 = phoneOf(tel);
        if (!e164) {
          if (say) say.textContent = 'That number does not look right. Include the country code.';
          return;
        }
        tel = e164;
      }

      /* ONE CHANNEL PER LIST. A list carries a single opt-in setting and the
         two channels want different ones: an address belongs on the list the
         moment it is typed, a number should confirm itself first, because that
         reply is the record that you were allowed to text at all. A list
         cannot be single and double at once, so the address and the number go
         to different lists and each gets the treatment it should have. */
      /* An extra question travels with the profile as a property, so it can be
         segmented and counted rather than read off a list of source strings. */
      var extra = form.querySelector('[data-ask-key]');
      var props = null;
      if (extra && extra.value.trim()) {
        props = {};
        props[extra.dataset.askKey] = extra.value.trim();
      }

      var posts = [];
      if (email) {
        var p1 = { email: email,
          subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } };
        if (props) p1.properties = props;
        posts.push({ props: p1, list: box.dataset.list });
      }
      if (tel.trim()) {
        posts.push({ props: { phone_number: tel.trim(),
          subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } } },
          list: box.dataset.listSms || box.dataset.list });
      }

      function send(p) {
        var body = { data: { type: 'subscription', attributes: {
          profile: { data: { type: 'profile', attributes: p.props } },
          custom_source: box.dataset.source || 'site' },
          relationships: p.list
            ? { list: { data: { type: 'list', id: p.list } } }
            : undefined } };
        return fetch(K_URL + encodeURIComponent(kid), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: K_REV },
          body: JSON.stringify(body),
        });
      }

      if (say) say.textContent = '…';
      /* both have to land, so a failure anywhere is the one that gets reported */
      Promise.all(posts.map(send)).then(function (rs) {
        return rs.filter(function (x) { return !x.ok; })[0] || rs[0];
      }).then(function (r) {
        /* Klaviyo answers 202 with no body when it has taken it */
        if (r.ok) {
          form.reset();
          /* A SUCCESS STATE IS THE BEST REAL ESTATE ON THE FORM, and the
             default use of it is a grey "Thanks!". Somebody who has just
             handed over a number is at the highest willingness they will ever
             be at, so where a done panel has been written, it takes the box —
             and what it asks for next costs nothing to grant. */
          /* THE PANELS BELONG TO THE SECTION, NOT TO THE FORM. joinform renders
             its own [data-join] box, so a section that wrapped it in another
             one got TWO handlers on one form and posted everything twice. The
             wrapper is a scope now and carries no behaviour of its own. */
          /* AND WHATEVER THE ANSWER UNLOCKS. A section can put its object
             under glass until somebody joins; joining is what takes it off,
             and it has to happen here rather than on a reload nobody does. */
          var veil = box.closest('[data-veil]')
            || (box.closest('.turn') || document).querySelector('[data-veil]');
          if (veil) veil.classList.add('is-lifted');

          var scope = box.closest('[data-join-scope]') || box;
          var done = scope.querySelector('[data-join-done]');
          if (done) {
            var ask = scope.querySelector('[data-join-ask]');
            if (ask) ask.hidden = true;
            done.hidden = false;
            /* the first heading inside may belong to a nested step that is
               still hidden, and focusing a hidden element goes nowhere */
            var h = [].slice.call(done.querySelectorAll('h2, h3, p, a'))
              .filter(function (el) { return el.offsetParent !== null; })[0];
            if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
            return;
          }
          if (say) say.textContent = box.dataset.thanks || 'Done.';
          return;
        }
        /* A mistyped number is the one failure a reader can actually fix, and
           "that did not go through" tells them nothing about how. */
        return r.json().then(function (j) {
          var e = (j && j.errors && j.errors[0]) || {};
          var phone = String(e.source && e.source.pointer || '').indexOf('phone') > -1;
          if (say) say.textContent = phone
            ? 'That number does not look right. Include the country code.'
            : 'That did not go through.';
        }, function () {
          if (say) say.textContent = 'That did not go through.';
        });
      }).catch(function () {
        if (say) say.textContent = 'That did not go through.';
      });
    });
  });
})();

/* ── the round ──────────────────────────────────────────────────────────────
   Some holes have something behind them. Pressing one opens it under the
   card, the way a note on the back of a scorecard works — not over the page,
   because a modal would turn a printed object into a gallery.

   One at a time, and pressing the same hole again puts it away. */
(function () {
  [].slice.call(document.querySelectorAll('.rnd')).forEach(function (card) {
    var panel = card.querySelector('[data-mem]');
    if (!panel) return;
    var holes = [].slice.call(card.querySelectorAll('[data-hole]'));
    var items = [].slice.call(panel.querySelectorAll('[data-mem-hole]'));
    /* TWO things close this — the scrim and the cross — and querySelector
       only ever returns the first. The scrim got the handler, the cross got
       nothing, so the one button that looks like a close button was the one
       that did not work. */
    var shut = [].slice.call(panel.querySelectorAll('[data-mem-close]'));
    var open = null;

    function stopClips() {
      [].slice.call(panel.querySelectorAll('video')).forEach(function (v) {
        if (!v.paused) v.pause();
      });
    }
    function show(n) {
      /* a second press on the same hole closes it */
      if (open === n) return close();
      open = n;
      stopClips();
      panel.hidden = false;
      panel.removeAttribute('aria-hidden');
      requestAnimationFrame(function () { panel.classList.add('is-open'); });
      items.forEach(function (f) { f.hidden = String(f.dataset.memHole) !== String(n); });
      holes.forEach(function (b) {
        var on = String(b.dataset.hole) === String(n);
        b.classList.toggle('is-open', on);
        b.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    }
    function close() {
      open = null;
      stopClips();
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      setTimeout(function () { if (open === null) panel.hidden = true; }, 260);
      holes.forEach(function (b) {
        b.classList.remove('is-open');
        b.setAttribute('aria-expanded', 'false');
      });
    }

    holes.forEach(function (b) {
      b.addEventListener('click', function () { show(b.dataset.hole); });
    });
    shut.forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && open !== null) close();
    });
  });
})();

/* ── the way back ───────────────────────────────────────────────────────────
   The hour bar is the control. It is already pinned to the top of every page,
   so making it the way back costs nothing on screen — no button riding beside
   the clock, nothing to notice until you want it.

   It only becomes pressable once there is a page and a half behind you.
   Clicking a status line that does nothing is worse than no affordance. */
(function () {
  var bar = document.querySelector('[data-to-top]');
  if (!bar) return;
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  bar.addEventListener('click', function () {
    if (!bar.hasAttribute('data-deep')) return;
    window.scrollTo({ top: 0, behavior: calm ? 'auto' : 'smooth' });
  });

  var ticking = false;
  function look() {
    ticking = false;
    var deep = window.scrollY > window.innerHeight * 1.5;
    if (deep === bar.hasAttribute('data-deep')) return;
    if (deep) bar.setAttribute('data-deep', '');
    else bar.removeAttribute('data-deep');
  }
  addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(look);
  }, { passive: true });
  look();
})();

/* ── what went out ──────────────────────────────────────────────────────────
   Dots on a photograph, each carrying its product on it. Hover does the work
   on a desktop — the card is inside the pin, so moving onto it keeps it open
   — and this only handles the case hover cannot: a thumb.

   One press opens the card, a press anywhere else puts it away, and the card
   itself is the link, so the second press is the product rather than a hunt
   for a button underneath. */
(function () {
  var pins = [].slice.call(document.querySelectorAll('[data-pin]'));
  if (!pins.length) return;

  function close() { pins.forEach(function (p) { p.classList.remove('is-on'); }); }

  pins.forEach(function (pin) {
    var spot = pin.querySelector('[data-spot]');
    if (!spot) return;
    spot.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var was = pin.classList.contains('is-on');
      close();
      if (!was) pin.classList.add('is-on');
    });
  });

  /* anywhere else on the page puts the open one away */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-pin]')) return;
    close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
})();


/* the dots land when the block arrives, not on page load — nothing should be
   moving before the reader has got there */
(function () {
  var frames = [].slice.call(document.querySelectorAll('[data-bag]'));
  if (!frames.length || !('IntersectionObserver' in window)) {
    frames.forEach(function (f) { f.classList.add('is-live'); });
    return;
  }
  var eye = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-live');
      eye.unobserve(e.target);
    });
  }, { threshold: 0.25 });
  frames.forEach(function (f) { eye.observe(f); });

  /* A portrait photograph at the full width of the column runs taller than the
     screen, and the frame cannot be cropped to fix it: the dots are placed as
     percentages OF THE FRAME, so cropping the picture would slide every marker
     off the thing it points at. The frame is capped by WIDTH instead, worked
     back from the picture's own ratio, which shortens it without moving
     anything. A tall picture also gets the words beside it rather than above,
     because a narrow plate alone in a wide column leaves half the page empty.
     Neither can be known until the file has loaded. */
  frames.forEach(function (f) {
    var img = f.querySelector('img');
    var sec = f.closest('.bag');
    if (!img || !sec) return;
    var fit = function () {
      if (!img.naturalWidth || !img.naturalHeight) return;
      var ar = img.naturalWidth / img.naturalHeight;
      f.style.setProperty('--ar', ar);
      sec.classList.toggle('is-tall', ar < 1);
      place(f);
    };
    if (img.complete) fit(); else img.addEventListener('load', fit, { once: true });
  });

  /* WHERE THE CARD GOES. Beside the dot that opened it — never at an edge of
     the picture, because an answer that appears somewhere else has to be gone
     looking for. Whether it fits beside the dot depends on the card's own
     width, which no CSS rule can ask about, so it is measured here.

     Preferred is down and to the right of the dot. If that runs past an edge
     the card flips to the other side; if neither side has room it centres on
     the dot; and it is clamped inside the frame last, so it can never leave
     the photograph however small the screen. The scale-in grows from the dot
     rather than from a corner, which is what makes the two read as one thing. */
  var GAP = 14, EDGE = 8;

  function place(frame) {
    var fw = frame.clientWidth, fh = frame.clientHeight;
    if (!fw || !fh) return;
    [].forEach.call(frame.querySelectorAll('[data-pin]'), function (pin) {
      var card = pin.querySelector('.bag__card');
      var spot = pin.querySelector('[data-spot]');
      if (!card || !spot) return;
      /* hidden, not display:none — so it still has a measurable size */
      var cw = card.offsetWidth, ch = card.offsetHeight;
      if (!cw || !ch) return;
      /* read the PERCENTAGES the block was authored with, off the pin. Asking
         the browser for the dot's computed `left` hands back pixels, and
         dividing those by 100 put one card 167px from its own dot. */
      var px = parseFloat(pin.style.getPropertyValue('--x'));
      var py = parseFloat(pin.style.getPropertyValue('--y'));
      if (!isFinite(px) || !isFinite(py)) return;
      var dx = px / 100 * fw, dy = py / 100 * fh;

      var cx = fit1(dx, cw, fw), cy = fit1(dy, ch, fh);
      pin.style.setProperty('--cx', cx + 'px');
      pin.style.setProperty('--cy', cy + 'px');
      pin.style.setProperty('--tx', '0px');
      pin.style.setProperty('--ty', '0px');
      pin.style.setProperty('--ox', (dx - cx) + 'px');
      pin.style.setProperty('--oy', (dy - cy) + 'px');
    });
  }

  /* one axis, twice: after the gap, after the flip, the clamp has the last word */
  function fit1(d, size, span) {
    var v = d + GAP;
    if (v + size > span - EDGE) v = (d - GAP - size >= EDGE) ? d - GAP - size : d - size / 2;
    return Math.max(EDGE, Math.min(v, span - size - EDGE));
  }

  frames.forEach(function (f) {
    place(f);
    /* on open, because a card measured before its font arrived is the wrong
       size, and the open is the only moment the number has to be right */
    [].forEach.call(f.querySelectorAll('[data-spot]'), function (s) {
      ['pointerenter', 'focus', 'click'].forEach(function (ev) {
        s.addEventListener(ev, function () { place(f); });
      });
    });
  });
  var t;
  addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(function () { frames.forEach(place); }, 150);
  });
})();


/* ── the globe ──────────────────────────────────────────────────────────────
   The atlas arrives as a sphere, turns once, and settles facing wherever the
   reader is before handing over to the flat map underneath.

   WHY IT ENDS. A globe that keeps turning hides half its dots at all times and
   gives a thumb nothing to aim at, and ninety-nine per cent of these dots are
   in one place — so a permanent spin would spend most of itself on empty ocean
   and cost the readout that finally works. It is an establishing shot.

   WHERE IT SETTLES. From the reader's own UTC offset, fifteen degrees to the
   hour. Not their city — the site never asks for that — just the meridian they
   keep time by, which is enough to arrive facing home. */
(function () {
  var wrap = document.querySelector('.atlas');
  var cv = wrap && wrap.querySelector('[data-atlas-globe]');
  var svg = wrap && wrap.querySelector('.atlas__svg');
  if (!cv || !svg) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var RAD = Math.PI / 180;

  /* the same paths the flat map draws, read back into longitude and latitude:
     the SVG holds x = lon + 180 and y = 78 - lat */
  function land() {
    return [].map.call(svg.querySelectorAll('.atlas__land'), function (p) {
      var nums = (p.getAttribute('d') || '').match(/-?[\d.]+/g) || [];
      var ring = [];
      for (var i = 0; i + 1 < nums.length; i += 2) {
        ring.push([+nums[i] - 180, 78 - +nums[i + 1]]);
      }
      return ring;
    }).filter(function (r) { return r.length > 3; });
  }
  function dots() {
    return [].map.call(svg.querySelectorAll('.atlas__p'), function (g) {
      var c = g.querySelector('.atlas__d');
      if (!c) return null;
      return { lon: +c.getAttribute('cx') - 180, lat: 78 - +c.getAttribute('cy'),
               r: +c.getAttribute('r'), el: g };
    }).filter(Boolean);
  }

  var RINGS = land(), DOTS = dots();
  if (!RINGS.length) return;
  /* tells the inline guard that this is alive, so it does not unhide the map */
  window.__wwdGlobe = true;

  var ctx = cv.getContext('2d');
  var W = 0, H = 0, R = 0, cxp = 0, cyp = 0, dpr = 1;

  /* ── THE PHOTOGRAPH, WRAPPED ROUND ──────────────────────────────────────
     The same Blue Marble the flat map places, read straight off the SVG so
     there is one source of truth and no second URL to keep in step. It is
     served from this domain, so getImageData does not taint the canvas.

     Sampled per pixel through the INVERSE of the projection two functions
     down — for each point on the disc, work out which longitude and latitude
     is under it, then look that up in the texture. That is what makes it a
     photographed sphere rather than a picture of a circle. */
  var TEX = null, TW = 0, TH = 0;
  var buf = document.createElement('canvas');
  var bctx = buf.getContext('2d', { willReadFrequently: true });

  (function texture() {
    var im = svg.querySelector('image');
    var href = im && (im.getAttribute('href') || im.getAttribute('xlink:href'));
    if (!href) return;
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      /* Capped: the globe is never more than a few hundred pixels across, and
         a 5400-wide source costs memory for detail nobody can see on it. */
      TW = Math.min(img.naturalWidth, 1600); TH = Math.round(TW / 2);
      var oc = document.createElement('canvas');
      oc.width = TW; oc.height = TH;
      var octx = oc.getContext('2d', { willReadFrequently: true });
      octx.drawImage(img, 0, 0, TW, TH);
      try { TEX = octx.getImageData(0, 0, TW, TH).data; } catch (e) { TEX = null; }
      if (settled) draw(home);
    };
    img.src = href;
  })();
  function size() {
    var b = cv.getBoundingClientRect();
    if (!b.width || !b.height) return false;
    dpr = Math.min(devicePixelRatio || 1, 2);
    W = b.width; H = b.height;
    cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    /* the photographed globe is the object the slide is about, so it takes
       the room a diagram did not need */
    var big = wrap.classList.contains('is-photo');
    R = Math.min(W, H) * (big ? 0.475 : 0.44);
    RZ = R * zoom; cxp = W / 2; cyp = H / 2;
    return true;
  }

  var TILT = 18 * RAD;                     /* a little off the equator, so it reads as a ball */
  var tilt = TILT, sinP0 = Math.sin(TILT), cosP0 = Math.cos(TILT);
  function setTilt(t) {
    tilt = Math.max(-1.25, Math.min(1.25, t));
    sinP0 = Math.sin(tilt); cosP0 = Math.cos(tilt);
  }
  /* RZ is R with the zoom applied. Everything that draws uses RZ; only size()
     knows about R, so a resize and a zoom cannot fight over the same value. */
  var zoom = 1, RZ = 0;

  function project(lon, lat, lam0) {
    var p = lat * RAD, l = (lon - lam0) * RAD;
    var cosp = Math.cos(p), sinp = Math.sin(p), cosl = Math.cos(l);
    var cosc = sinP0 * sinp + cosP0 * cosp * cosl;
    if (cosc < 0) return null;             /* the far side of the world */
    return [cxp + RZ * cosp * Math.sin(l),
            cyp - RZ * (cosP0 * sinp - sinP0 * cosp * cosl)];
  }

  /* The globe is the same map, so it takes the same three colors. It used to
     derive everything from currentColor at different alphas, which was the
     canvas half of the reason the atlas read as a tinted panel. */
  var cs = getComputedStyle(svg);
  var ink = cs.color || '#fff';
  var wrapCs = getComputedStyle(wrap);
  var LAND = (wrapCs.getPropertyValue('--land') || '').trim();
  var PIN = (wrapCs.getPropertyValue('--pin') || '').trim();
  function rgba(a) {
    var m = ink.match(/-?[\d.]+/g) || [255, 255, 255];
    return 'rgba(' + m[0] + ',' + m[1] + ',' + m[2] + ',' + a + ')';
  }

  /* One buffer at globe size, reused. The maths runs in buffer pixels and the
     result is scaled to the canvas, so a retina screen costs no more work. */
  var BR = 0;
  function earth(lam0, fast) {
    if (!TEX) return false;
    /* Coarse while it is turning, fine once it has stopped. Nobody can see
       the difference at 60fps and everybody can see it standing still. */
    var cap = fast ? 260 : 620;
    var n = Math.max(64, Math.min(Math.round(RZ * 2), cap));
    if (buf.width !== n) { buf.width = n; buf.height = n; BR = n / 2; }
    var id = bctx.createImageData(n, n), out = id.data;
    for (var py = 0; py < n; py++) {
      var yy = (py - BR + 0.5) / BR, Y = -yy, y2 = yy * yy;
      for (var px = 0; px < n; px++) {
        var xx = (px - BR + 0.5) / BR;
        var rho2 = xx * xx + y2;
        if (rho2 > 1) continue;                       /* off the ball */
        var rho = Math.sqrt(rho2);
        var c = Math.asin(rho), cosc = Math.cos(c), sinc = Math.sin(c);
        var lat = Math.asin(cosc * sinP0 + (rho ? (Y * sinc * cosP0) / rho : 0)) / RAD;
        var lon = lam0 + Math.atan2(xx * sinc, rho * cosc * cosP0 - Y * sinc * sinP0) / RAD;
        var u = (((lon + 180) % 360) + 360) % 360;
        var sx = (u / 360 * TW) | 0, sy = ((90 - lat) / 180 * TH) | 0;
        if (sx >= TW) sx = TW - 1; if (sx < 0) sx = 0;
        if (sy >= TH) sy = TH - 1; if (sy < 0) sy = 0;
        var si = (sy * TW + sx) * 4, di = (py * n + px) * 4;
        /* limb darkening — a flat disc of photograph does not read as a ball
           until the edge falls away from the light */
        var sh = 0.42 + 0.58 * Math.sqrt(1 - rho2);
        out[di] = TEX[si] * sh;
        out[di + 1] = TEX[si + 1] * sh;
        out[di + 2] = TEX[si + 2] * sh;
        out[di + 3] = 255;
      }
    }
    bctx.putImageData(id, 0, 0);
    ctx.clearRect(0, 0, W, H);
    ctx.drawImage(buf, cxp - RZ, cyp - RZ, RZ * 2, RZ * 2);
    return true;
  }

  function draw(lam0, fast) {
    if (earth(lam0, fast)) { pins(lam0); return; }
    ctx.clearRect(0, 0, W, H);
    /* the sphere itself, a shade off the ground so the edge exists */
    ctx.beginPath(); ctx.arc(cxp, cyp, RZ, 0, Math.PI * 2);
    ctx.fillStyle = rgba(0.07); ctx.fill();

    ctx.fillStyle = LAND || rgba(0.20);
    for (var i = 0; i < RINGS.length; i++) {
      var ring = RINGS[i], started = false;
      ctx.beginPath();
      for (var j = 0; j < ring.length; j++) {
        var q = project(ring[j][0], ring[j][1], lam0);
        if (!q) { started = false; continue; }   /* break where it goes round the back */
        if (!started) { ctx.moveTo(q[0], q[1]); started = true; }
        else ctx.lineTo(q[0], q[1]);
      }
      ctx.fill();
    }

    pins(lam0);
  }

  function pins(lam0) {
    for (var k = 0; k < DOTS.length; k++) {
      var d = DOTS[k], p = project(d.lon, d.lat, lam0);
      if (!p) continue;
      var rr = Math.max(1.1, d.r * (RZ / 33));   /* the flat map's radii are in its own units */
      ctx.beginPath(); ctx.arc(p[0], p[1], rr, 0, Math.PI * 2);
      ctx.fillStyle = PIN || rgba(0.95); ctx.fill();
      /* over a photograph the pin needs an edge, same as on the flat map */
      if (TEX) { ctx.lineWidth = Math.max(0.6, rr * 0.34);
                 ctx.strokeStyle = 'rgba(4,18,15,.85)'; ctx.stroke(); }
    }
  }

  /* Fifteen degrees to the hour, from the reader's own clock — but STANDARD
     time, not whatever it is today. New York in August is UTC-4, which points
     at open Atlantic; in January it is UTC-5, which is New York. Taking the
     further-west of January and July gets the zone's own meridian and works
     the same way south of the equator, where the seasons are the other way
     round. */
  var y = new Date().getFullYear();
  var jan = new Date(y, 0, 1).getTimezoneOffset();
  var jul = new Date(y, 6, 1).getTimezoneOffset();
  var home = -(Math.max(jan, jul) / 60) * 15;
  while (home > 180) home -= 360;
  while (home < -180) home += 360;

  var SPIN = 3200, spun = false;
  var settled = false;               /* the globe has arrived and is staying */
  function run(t0) {
    var step = function (t) {
      var e = Math.min(1, (t - t0) / SPIN);
      var ease = 1 - Math.pow(1 - e, 3);
      draw(home - 360 * (1 - ease));
      if (e < 1) requestAnimationFrame(step);
      else {
        /* IT STAYS. Handing over to the flat map made sense when the globe was
           a diagram; a photographed Earth is the thing worth looking at, so it
           keeps the frame. The flat map remains underneath as the fallback for
           anyone whose globe never starts. */
        settled = true;
        wrap.classList.remove('is-spinning');
        wrap.classList.remove('is-armed');
        wrap.classList.add('is-orb');
        draw(home);
      }
    };
    requestAnimationFrame(step);
  }

  function start() {
    if (spun || !size()) return;
    spun = true;
    wrap.classList.add('is-spinning');
    draw(home - 360);
    requestAnimationFrame(function (t) { run(t); });
  }

  /* only once the face is genuinely open — a clipped face is still "on screen"
     as far as an observer is concerned, and the spin would finish behind the shop */
  var rules = svg.closest('.turn__rules');
  if (rules) {
    if (rules.classList.contains('is-live')) start();
    rules.addEventListener('wwd:face', function (e) { if (e.detail && e.detail.open) start(); });
  }

  /* AND SIMPLY BEING ON SCREEN, whether or not the face announced itself.
     This used to be the `else` branch, reached only when there was no
     .turn__rules at all — so on the page that HAS one, the globe waited on two
     cues that can both never arrive: is-live is added by a different observer
     AFTER this module has already read it, and wwd:face only fires for a rail
     that reports its faces. Neither happened.

     The cost of that was not a missing animation. is-armed holds the flat map
     at opacity 0 so the globe can play first, so the atlas sat armed forever
     and the whole section rendered as an empty colored field. Every dot, and
     every coastline, on the live site, invisible. */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { start(); io.disconnect(); } });
    }, { threshold: 0.35 });
    io.observe(wrap);
  } else start();

  /* ── TURN IT, AND GO SOMEWHERE ───────────────────────────────────────────
     A photographed globe that cannot be turned is a photograph. Horizontal
     drag spins it; vertical is left to the page, which is why touch-action is
     pan-y rather than none — taking the whole gesture would trap a thumb
     halfway down a long page with no way past.

     A tap near a place flies to it and zooms; a tap on open water zooms back
     out. The tap does NOT reimplement the readout — it dispatches a click on
     the flat map's own dot, so the number, the label and the highlighted row
     in the list below all update through the code that already did that. */
  var lam = home, dragging = false, lastX = 0, lastY = 0, moved = 0, pid = null, anim = null;

  cv.style.touchAction = 'pan-y';
  cv.style.cursor = 'grab';
  cv.style.pointerEvents = 'auto';

  function stopAnim() { if (anim) { cancelAnimationFrame(anim); anim = null; } }

  cv.addEventListener('pointerdown', function (e) {
    if (!settled) return;
    stopAnim();
    e.stopPropagation();                 /* the rail must not also read this */
    dragging = true; moved = 0; lastX = e.clientX; lastY = e.clientY; pid = e.pointerId;
    try { cv.setPointerCapture(pid); } catch (err) {}
    cv.style.cursor = 'grabbing';
  });

  cv.addEventListener('pointermove', function (e) {
    if (!dragging) return;
    var dx = e.clientX - lastX, dy = e.clientY - lastY;
    lastX = e.clientX; lastY = e.clientY;
    moved += Math.abs(dx) + Math.abs(dy);
    /* a canvas width is about half a turn, so the ball keeps up with a thumb */
    lam -= dx * (180 / Math.max(120, W));
    if (e.pointerType !== 'touch') setTilt(tilt + dy * 0.006);
    draw(lam, true);
  });

  function letGo(e) {
    if (!dragging) return;
    dragging = false;
    cv.style.cursor = 'grab';
    try { cv.releasePointerCapture(pid); } catch (err) {}
    if (moved < 7) tap(e); else draw(lam);   /* a still frame gets the fine one */
  }
  cv.addEventListener('pointerup', letGo);
  cv.addEventListener('pointercancel', function () { dragging = false; cv.style.cursor = 'grab'; });

  /* the inverse of project(): which longitude and latitude is under this pixel */
  function unproject(clientX, clientY) {
    var b = cv.getBoundingClientRect();
    var x = (clientX - b.left - cxp) / RZ;
    var y = -(clientY - b.top - cyp) / RZ;
    var rho2 = x * x + y * y;
    if (rho2 > 1) return null;                       /* they missed the ball */
    var rho = Math.sqrt(rho2), c = Math.asin(rho);
    var cosc = Math.cos(c), sinc = Math.sin(c);
    return [lam + Math.atan2(x * sinc, rho * cosc * cosP0 - y * sinc * sinP0) / RAD,
            Math.asin(cosc * sinP0 + (rho ? (y * sinc * cosP0) / rho : 0)) / RAD];
  }

  function goTo(lon, lat, z) {
    stopAnim();
    var l0 = lam, t0 = tilt, z0 = zoom;
    var dl = ((lon - l0 + 540) % 360) - 180;         /* the short way round */
    var t1 = lat * RAD, s0 = null;
    anim = requestAnimationFrame(function run(ts) {
      if (s0 === null) s0 = ts;
      var e = Math.min(1, (ts - s0) / 700), k = 1 - Math.pow(1 - e, 3);
      lam = l0 + dl * k;
      setTilt(t0 + (t1 - t0) * k);
      zoom = z0 + (z - z0) * k; RZ = R * zoom;
      draw(lam, e < 1);
      anim = e < 1 ? requestAnimationFrame(run) : null;
    });
  }

  function tap(e) {
    var b = cv.getBoundingClientRect();
    var tx = e.clientX - b.left, ty = e.clientY - b.top;
    if (Math.sqrt((tx - cxp) * (tx - cxp) + (ty - cyp) * (ty - cyp)) > RZ) {
      /* off the ball entirely */
      if (zoom > 1.05) goTo(lam, TILT / RAD, 1);
      return;
    }

    /* IN PIXELS, NOT IN DEGREES. This used to measure angular distance and
       accept anything within nine degrees — but nine degrees is a wide target
       at the centre of the disc and almost nothing near the limb, where the
       sphere is turning away from you. The tolerance moved under the finger,
       which is why it felt broken rather than fussy.

       Every dot is projected to where it actually IS on screen and the nearest
       within a thumb's width wins. Dots on the far side project to null and
       are skipped, so you cannot select a city through the planet. */
    var best = null, bd = 1e9;
    for (var i = 0; i < DOTS.length; i++) {
      var q = project(DOTS[i].lon, DOTS[i].lat, lam);
      if (!q) continue;
      var dx = q[0] - tx, dy = q[1] - ty;
      var dd = Math.sqrt(dx * dx + dy * dy);
      if (dd < bd) { bd = dd; best = DOTS[i]; }
    }
    if (best && bd < 34) {
      goTo(best.lon, best.lat, Math.min(2.4, zoom < 1.4 ? 2.4 : zoom));
      /* dispatchEvent, not .click(). click() lives on HTMLElement and these
         are SVG <g>s, so the call was simply absent and the readout never
         heard the tap — the label kept cycling on its own timer and looked
         like it had responded. */
      if (best.el) best.el.dispatchEvent(new MouseEvent('click', { bubbles: true }));
    } else if (zoom > 1.05) {
      goTo(lam, TILT / RAD, 1);
    }
  }
  /* a pointer over the ball should say it can be turned */
  cv.addEventListener('pointermove', function (e) {
    if (dragging || e.pointerType === 'touch') return;
    var b = cv.getBoundingClientRect();
    var dx = e.clientX - b.left - cxp, dy = e.clientY - b.top - cyp;
    cv.style.cursor = Math.sqrt(dx * dx + dy * dy) <= RZ ? 'grab' : 'default';
  });


  /* A FLOOR UNDER ALL OF IT. The inline guard in loud.liquid already drops
     is-armed when this script never loads — but not when it loads and then
     never starts, which is exactly what happened. Nothing may hide the content
     indefinitely because a decoration missed its cue. */
  setTimeout(function () { if (!spun) wrap.classList.remove('is-armed'); }, 4000);
})();

/* ── the one interruption ────────────────────────────────────────────────────
   A popup is, by construction, the persuasion mechanic this site argues
   against — so it is allowed exactly one job, in exactly one place, under
   rules that keep it from becoming the thing everybody closes.

   IT IS NOT ON THE HOMEPAGE. That page's whole argument is belonging rather
   than selling, and an interstitial in the first three seconds contradicts it.
   It goes where somebody has already declared commercial intent.

   IT WAITS FOR A SIGNAL. Either the reader has gone deep enough to be reading
   rather than bouncing, or the pointer has left for the tab bar. A timer says
   nothing about whether anybody is interested.

   IT ASKS ONCE. Dismissed or answered, it is remembered and never shown again.
   A popup that reappears is not a request, it is a toll. */
(function () {
  var box = document.querySelector('[data-nudge]');
  if (!box) return;

  var key = box.dataset.key || 'wwd-nudge';
  var store;
  try { store = window.localStorage; } catch (e) { store = null; }
  if (store && store.getItem(key)) return;

  var depth = parseFloat(box.dataset.depth || '45') / 100;
  var exitOn = box.dataset.exit !== 'off';
  var shown = false, lastFocus = null;

  function close(remember) {
    box.hidden = true;
    box.classList.remove('is-open');
    document.documentElement.style.removeProperty('overflow');
    if (remember && store) { try { store.setItem(key, String(Date.now())); } catch (e) {} }
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function open() {
    if (shown) return;
    shown = true;
    lastFocus = document.activeElement;
    box.hidden = false;
    /* a frame between unhiding and the class, so the transition has a start */
    requestAnimationFrame(function () { box.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
    var first = box.querySelector('input:not([hidden]), button');
    /* NOT autofocused on a phone. Focusing a tel input summons the keyboard
       over the thing being read, which is a worse first impression than the
       popup itself. */
    if (first && window.matchMedia('(min-width:900px)').matches) {
      first.focus({ preventScroll: true });
    }
    /* remembered on open, not on close: a reader who scrolls past it without
       answering has still been asked, and asking twice is the failure mode */
    if (store) { try { store.setItem(key, String(Date.now())); } catch (e) {} }
  }

  [].slice.call(box.querySelectorAll('[data-nudge-close]')).forEach(function (b) {
    b.addEventListener('click', function () { close(true); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !box.hidden) close(true);
  });

  /* FOCUS STAYS IN THE DIALOG. Tabbing out of an open modal into the page
     behind it leaves a keyboard reader somewhere they cannot see. */
  box.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || box.hidden) return;
    var f = [].slice.call(box.querySelectorAll(
      'a[href], button, input:not([hidden]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  function onScroll() {
    var seen = (window.scrollY + window.innerHeight) / document.body.scrollHeight;
    if (seen >= depth) { open(); window.removeEventListener('scroll', onScroll); }
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  if (exitOn && window.matchMedia('(min-width:900px)').matches) {
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 0) open();
    });
  }
})();

/* ── how long until the door opens ───────────────────────────────────────────
   Teaser Tuesday counts to a weekday and an hour, which recurs forever. This
   counts to one specific moment that happens once, so it is its own thing.

   Counted against the SHOP's wall clock rather than the reader's, so everyone
   waits for the same instant — "opens in four hours" meaning two different
   moments in Perth and Orlando is not counting to anything real.

   THE TRICK: read the shop's wall clock back out of a formatted date and
   treat both it and the target as naive numbers. The gap between two naive
   readings of the same zone is the true gap, and daylight saving is included
   for free because the zone is re-read on every tick rather than resolved
   once into an offset. */
(function () {
  var el = document.querySelector('[data-until]');
  if (!el || !window.Intl) return;
  var out = el.querySelector('[data-until-out]');
  var now = el.querySelector('[data-until-now]');
  if (!out) return;

  /* "2026-08-12 14:30" — and "2026-08-12" alone means the start of that day */
  var m = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/.exec((el.dataset.at || '').trim());
  if (!m) { el.hidden = true; return; }
  var target = Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0), 0);

  var parts;
  try {
    parts = new Intl.DateTimeFormat('en-US', {
      timeZone: el.dataset.zone, hourCycle: 'h23',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
    });
    parts.formatToParts(new Date());
  } catch (e) { el.hidden = true; return; }

  function shopNaive() {
    var p = parts.formatToParts(new Date()).reduce(function (o, x) { o[x.type] = x.value; return o; }, {});
    return Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second);
  }

  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var timer;

  function paint() {
    var s = Math.floor((target - shopNaive()) / 1000);
    if (s <= 0) {
      /* AT ZERO IT STOPS BEING A CLOCK. A timer frozen at 00:00:00:00 reads as
         broken; the shop being open reads as imminent, which is the truth. */
      if (now) { now.hidden = false; }
      out.parentNode.hidden = true;
      if (timer) clearInterval(timer);
      return;
    }
    var d = Math.floor(s / 86400);
    var h = Math.floor((s % 86400) / 3600);
    var mi = Math.floor((s % 3600) / 60);
    out.textContent = (d > 0 ? d + ':' : '') + pad(h) + ':' + pad(mi) + ':' + pad(s % 60);
  }

  paint();
  timer = setInterval(paint, 1000);
})();

/* The form's copy was fixed at source in Klaviyo on 2026-08-05, so the text
   rewriter that lived here — a MutationObserver rewriting "Want 10% off your
   first drop?" out of a form the API cannot edit — has nothing left to match
   and is gone. The theme setting that fed it stays: the same trick will be
   needed again the next time a line has to change faster than a form can be
   republished, and the comment in main-password.liquid explains the shape. */


/* ── which step is the form on ───────────────────────────────────────────────
   Klaviyo exposes no state for this — no event, no attribute, nothing on the
   window. What it does expose is the DOM, and the fields are unambiguous:

     a visible email input   -> the last step
     a visible tel input     -> the first
     neither                 -> the code step, which is the only one left

   The theme's own headline and line swap to match, so every sentence on this
   page is set in the theme's face on the theme's rhythm and the form supplies
   nothing but the inputs. */
(function () {
  var page = document.querySelector('.pwx');
  var slot = page && page.querySelector('.pwx__embed');
  if (!slot) return;

  var seen = function (el) { return el && el.offsetParent !== null; };

  function step() {
    /* NOT RENDERED YET is not a step. Before Klaviyo injects anything there
       are no fields to read, and guessing from that emptiness is how the
       success copy ends up greeting somebody who has not typed a digit. */
    if (!slot.querySelector('form')) return 'phone';
    if (seen(slot.querySelector('input[type="email"]'))) return 'email';
    if (seen(slot.querySelector('input[type="tel"]'))) return 'phone';
    /* THE SUCCESS STEP HAS NO FIELDS. That is the whole signal — every other
       step is asking for something. Without this the last slide kept whatever
       copy the step before it had, which is why it was still offering the
       priority list to somebody who had already joined it. */
    var asking = [].slice.call(slot.querySelectorAll('input')).some(seen);
    if (!asking) return 'done';
    return 'code';
  }

  var current = null;
  function paint() {
    var now = step();
    if (now === current) return;
    current = now;
    [].slice.call(page.querySelectorAll('[data-say]')).forEach(function (el) {
      el.hidden = el.dataset.say !== now;
    });
    page.dataset.step = now;
  }

  paint();
  new MutationObserver(paint).observe(slot, {
    childList: true, subtree: true, attributes: true,
    attributeFilter: ['style', 'class', 'hidden'],
  });
})();


/* ── a word about the music ─────────────────────────────────────────────────
   The crate is a disc in the corner of a header: a good place for a control
   and a bad one for an invitation, because nobody presses a thing they have
   not noticed. This says it exists — once a session, after enough of the page
   has gone by that the reader has settled, and never again once answered or
   waved off.

   It has two things to say and the difference matters. Before anything has
   played it is an offer. After a navigation it is an explanation: the record
   did not end, the browser threw the document away, and the position is still
   there. Saying only the first would invite somebody to start again from the
   top of a song they were halfway through. */
(function () {
  var box = document.querySelector('[data-mnudge]');
  if (!box) return;
  /* nothing to point at, nothing to say */
  if (!document.querySelector('[data-track]')) return;

  /* TWO MESSAGES, TWO MEMORIES. They had one between them, and it was set by
     the very thing that makes the second one relevant: the invite showed on
     the first page, marked itself seen, and every page after that returned
     here — so "music stopped on the page change" could never appear. Starting
     the music set the same flag, which switched off the notice written for
     people who had started the music.

     The invite is once a session: it is an offer and a second offer is
     nagging. The notice is not an offer, it is an explanation of something
     that just happened, and it happens again on every navigation — so it
     comes back unless somebody has actually waved it away. */
  var SEEN = 'wwd.mnudge';
  var SEEN_BACK = 'wwd.mnudge.back';
  var got = function (k) { try { return !!sessionStorage.getItem(k); } catch (e) { return false; } };
  var put = function (k) { try { sessionStorage.setItem(k, '1'); } catch (e) {} };

  var say = box.querySelector('[data-mnudge-say]');
  var go = box.querySelector('[data-mnudge-go]');
  var shut = box.querySelector('[data-mnudge-close]');
  /* SCREENS, NOT PAGE LENGTH. 15% of the homepage is 2,600px — two and a half
     screens, well past the grid — while 15% of a short collection page is
     almost immediate. What the reader experiences is "how many scrolls", and
     that is a multiple of the viewport. 120% lands about the third row of the
     product grid on a phone. */
  var screens = (parseFloat(box.dataset.at) || 120) / 100;
  var shown = false, playing = false, variant = 'new';

  /* If something is already playing there is nothing to point out. */
  document.addEventListener('wwd:playing', function (e) {
    playing = !!(e.detail && e.detail.playing);
    /* something is playing, so there is nothing to point out — but this must
       not silence the notice, which exists for the moment that playing stops */
    if (playing && shown) done(false);
    else if (playing) { box.hidden = true; }
  });

  /* Waving it away is the only thing that silences the notice. Pressing it
     must not: pressing it resumes the record, and the next navigation will
     stop that record too — the explanation is worth having again. */
  function done(quiet) {
    box.classList.remove('is-up');
    setTimeout(function () { box.hidden = true; }, 340);
    var mark = variant === 'back' ? (quiet ? SEEN_BACK : null) : SEEN;
    if (mark) put(mark);
    window.removeEventListener('scroll', onScroll);
  }

  function held() {
    /* what the crate stashed on the way out of the last page */
    try { return JSON.parse(sessionStorage.getItem('wwd.crate.at')); } catch (e) { return null; }
  }

  function show() {
    if (shown || playing) return;
    var was = held();
    var back = box.dataset.back;
    /* the record was going when the last document was thrown away, and it is
       not going now — that is the notice, not the offer */
    variant = (was && was.playing && back) ? 'back' : 'new';
    if (got(variant === 'back' ? SEEN_BACK : SEEN)) return;
    shown = true;
    if (variant === 'back') say.textContent = back;
    box.dataset.variant = variant;
    box.hidden = false;
    requestAnimationFrame(function () { box.classList.add('is-up'); });
  }

  function onScroll() {
    if (window.scrollY >= window.innerHeight * screens) show();
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  if (go) {
    go.addEventListener('click', function () {
      /* This click IS the gesture the browser wanted. Toggle goes through the
         crate, which resumes the stashed record at its stashed position, or
         starts the first one if there is nothing held. */
      document.dispatchEvent(new CustomEvent('wwd:control', { detail: { action: 'toggle' } }));
      done(false);
    });
  }
  if (shut) shut.addEventListener('click', function () { done(true); });
})();

/* ── the opening frame ──────────────────────────────────────────────────────
   Four slides at most, one on show, and a control strip that tells you where
   you are.

   NOTHING MOVES UNTIL IT IS LOOKED AT and nothing keeps moving once it is
   not. A hero that runs while it is scrolled past is spending a phone's
   battery on frames nobody is watching, and on a page this long that is most
   of the visit.

   VIDEO IS STARTED HERE, NOT BY THE MARKUP. The tag ships without autoplay so
   four videos do not race for the connection on the first screen; the one on
   show is played and the rest are paused and rewound. A slide holding a video
   also waits for the video rather than cutting it off mid-shot — a six second
   dwell over a twelve second clip means nobody ever sees the end of it.

   prefers-reduced-motion turns the timer off entirely and leaves the controls
   working. That setting means "do not move things at me", not "do not let me
   look at the other slides". */
(function () {
  var wraps = document.querySelectorAll('[data-hero]');
  if (!wraps.length) return;

  var still = window.matchMedia('(prefers-reduced-motion: reduce)');

  Array.prototype.forEach.call(wraps, function (wrap) {
    var slides = wrap.querySelectorAll('[data-slide]');
    var dots = wrap.querySelectorAll('[data-dot]');
    var pp = wrap.querySelector('[data-pp]');
    if (!slides.length) return;

    /* ONE SLIDE IS NOT A CAROUSEL, BUT IT IS STILL A VIDEO. This used to
       return here below two slides, which was right about the carousel and
       wrong about everything else: a lone hero video then had nothing
       watching it, so it played on into a page nobody was looking at any
       more. The markup autoplays the first slide; this is what stops it. */
    if (slides.length < 2) {
      var only = slides[0].querySelector('video');
      if (!only) return;
      var play = function () { var p = only.play(); if (p && p.catch) p.catch(function () {}); };
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          if (es[0].isIntersecting) play(); else only.pause();
        }, { threshold: 0.15 }).observe(wrap);
      }
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) only.pause(); else play();
      });
      return;
    }

    var at = 0;
    var timer = null;
    var seen = false;         /* is any of it on screen */
    var held = false;         /* has somebody pressed pause */
    var base = parseInt(wrap.style.getPropertyValue('--hro-ms'), 10) || 6000;

    var vid = function (i) { return slides[i].querySelector('video'); };

    /* How long slide i should stay. A video decides for itself once its
       metadata has arrived; before that it falls back to the dwell, which is
       also what every photograph uses. */
    function dwellOf(i) {
      var v = vid(i);
      if (v && isFinite(v.duration) && v.duration > 0) {
        return Math.max(base, Math.round(v.duration * 1000));
      }
      return base;
    }

    function show(i, why) {
      if (i === at) return;
      var was = at;
      at = (i + slides.length) % slides.length;

      for (var s = 0; s < slides.length; s++) {
        var on = s === at;
        slides[s].classList.toggle('is-on', on);
        /* inert keeps a press on a hidden slide off the tab order — a
           keyboard lands on a button it cannot see otherwise */
        if (on) { slides[s].removeAttribute('aria-hidden'); slides[s].removeAttribute('inert'); }
        else { slides[s].setAttribute('aria-hidden', 'true'); slides[s].setAttribute('inert', ''); }

        var v = slides[s].querySelector('video');
        if (v) {
          if (on) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else { v.pause(); try { v.currentTime = 0; } catch (e) {} }
        }
      }
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.toggle('is-on', d === at);
        if (d === at) dots[d].setAttribute('aria-current', 'true');
        else dots[d].removeAttribute('aria-current');
      }
      if (why === 'hand') hold(true);   /* a press means they are steering */
      else arm();
      void was;
    }

    function arm() {
      clearTimeout(timer);
      if (held || !seen || still.matches) return;
      timer = setTimeout(function () { show(at + 1); }, dwellOf(at));
    }

    function hold(on) {
      held = on;
      clearTimeout(timer);
      if (pp) {
        pp.classList.toggle('is-held', on);
        pp.setAttribute('aria-pressed', on ? 'true' : 'false');
        pp.setAttribute('aria-label', on ? 'Play' : 'Pause');
      }
      if (!on) arm();
    }

    var prev = wrap.querySelector('[data-prev]');
    var next = wrap.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { show(at - 1, 'hand'); });
    if (next) next.addEventListener('click', function () { show(at + 1, 'hand'); });
    if (pp) pp.addEventListener('click', function () { hold(!held); });
    for (var d = 0; d < dots.length; d++) {
      (function (i) {
        dots[i].addEventListener('click', function () { show(i, 'hand'); });
      })(d);
    }

    /* A THUMB IS THE CONTROL MOST PEOPLE WILL REACH FOR. Horizontal only, and
       only past a threshold, so a vertical scroll that wanders a few pixels
       sideways does not change the slide out from under them. */
    var x0 = null, y0 = null;
    wrap.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    wrap.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        show(dx < 0 ? at + 1 : at - 1, 'hand');
      }
      x0 = null; y0 = null;
    }, { passive: true });

    wrap.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { show(at - 1, 'hand'); e.preventDefault(); }
      if (e.key === 'ArrowRight') { show(at + 1, 'hand'); e.preventDefault(); }
    });

    /* off screen, or the tab is in the background: stop entirely */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        seen = es[0].isIntersecting;
        if (seen) {
          var v = vid(at);
          if (v && !held) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          arm();
        } else {
          clearTimeout(timer);
          var w = vid(at); if (w) w.pause();
        }
      }, { threshold: 0.25 }).observe(wrap);
    } else {
      seen = true; arm();
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { clearTimeout(timer); var v = vid(at); if (v) v.pause(); }
      else if (seen) { var w = vid(at); if (w && !held) { var p = w.play(); if (p && p.catch) p.catch(function () {}); } arm(); }
    });

    still.addEventListener('change', arm);

    /* start whatever is already on screen */
    var first = vid(0);
    if (first) { var q = first.play(); if (q && q.catch) q.catch(function () {}); }
  });
})();

/* ── the hand-off ───────────────────────────────────────────────────────────
   The cue under the opening frame goes as soon as the page moves. It is
   decoration and nothing depends on it, so this does the least it can: one
   passive listener, removed the first time it fires. */
(function () {
  var cues = document.querySelectorAll('[data-cue]');
  if (!cues.length) return;
  function gone() {
    if (window.scrollY < 24) return;
    Array.prototype.forEach.call(cues, function (c) { c.classList.add('is-gone'); });
    window.removeEventListener('scroll', gone);
  }
  window.addEventListener('scroll', gone, { passive: true });
  gone();   /* a reload part-way down the page should not show it at all */
})();

/* ── how far along the category rail ────────────────────────────────────────
   The bar reads the scroller rather than counting cards, so it stays true if
   a card is added, removed or resized — and it costs one passive listener. */
(function () {
  var rails = document.querySelectorAll('[data-rack]');
  if (!rails.length) return;
  Array.prototype.forEach.call(rails, function (rail) {
    var bar = rail.parentElement.querySelector('[data-rack-bar] i');
    if (!bar) return;
    function draw() {
      var span = rail.scrollWidth - rail.clientWidth;
      var frac = rail.clientWidth / rail.scrollWidth;
      bar.style.setProperty('--w', (frac * 100).toFixed(2) + '%');
      /* translate across the space the thumb does NOT occupy, so the right
         edge lands exactly at the end rather than overshooting by its width */
      var at = span > 0 ? rail.scrollLeft / span : 0;
      bar.style.setProperty('--x', (at * ((1 / frac) - 1) * 100).toFixed(2) + '%');
    }
    rail.addEventListener('scroll', draw, { passive: true });
    window.addEventListener('resize', draw);
    draw();
  });
})();

/* ── how tall the header actually is ────────────────────────────────────────
   Two things need it and neither can know it: the hour bar pins underneath
   the header, and the full-height hero subtracts it. Both were running on a
   hardcoded fallback, which is right until somebody changes the logo width
   setting and then silently wrong by exactly how much they changed it.

   ONLY --hdr-h IS SET HERE. --hour-h already has an owner — the transport
   module measures it, because the bar's height depends on whether the music
   player is docked into it. Two writers on one custom property is a race
   decided by listener order, and the wrong winner would move the whole page
   down by the height of a music player. */
(function () {
  var hdr = document.querySelector('#shopify-section-header');
  if (!hdr) return;
  function measure() {
    document.documentElement.style.setProperty(
      '--hdr-h', Math.round(hdr.getBoundingClientRect().height) + 'px');
  }
  measure();
  window.addEventListener('resize', measure);
  if ('ResizeObserver' in window) new ResizeObserver(measure).observe(hdr);
})();

/* ── the chrome arrives invisible ───────────────────────────────────────────
   On a page opening with a full-bleed frame, the bars start transparent with
   white on them and paint themselves the moment the page moves.

   IT IS OPT-IN PER PAGE, not per site. The body only gets .is-cover when a
   hero on THIS page asked to sit under the chrome — on a product page or a
   collection the bar has cream behind it from the first pixel, and white on
   cream is not a style, it is invisible.

   rAF-throttled: scroll fires far faster than the screen can redraw, and this
   only ever writes one class. */
(function () {
  if (!document.querySelector('.hro--cover')) return;
  var b = document.body;
  b.classList.add('is-cover');
  var ticking = false;
  function read() {
    ticking = false;
    /* a few pixels of slack so a rubber-band bounce at the very top does not
       flicker the bar on and off under somebody's thumb */
    b.classList.toggle('at-top', window.scrollY < 8);
  }
  read();
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(read);
  }, { passive: true });
})();
